var Countries = {
	"Afghanistan": {
		"code": "AF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/af-eb8e279df9906ed3fd391df59a7a475f754748edaa733071b57c0a641b8d24fd.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Aland Islands": {
		"code": "AX",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ax-d46239a9579497bc01912679a9ec11a38899af9741fbb50f520a1bb0075a4055.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Albania": {
		"code": "AL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/al-77334b551675f1722f013e89984e0650736057dfa3969e70fd268ff9d61886bb.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Algeria": {
		"code": "DZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/dz-9812959bac8cecc27f421e0651c970978d33b90f2b9e3ec6ba189331708e906f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Province"
	},
	"Andorra": {
		"code": "AD",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ad-2d3299fc054096c47ab0c45f9d10614bb0d939ccc4d1c688078c7b1bfbec2a01.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Angola": {
		"code": "AO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ao-02cfc2219fd71679d14ef2c7afc3e6122ae0d7685e28281322aa8ea66d1dc4a8.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Anguilla": {
		"code": "AI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ai-7b0902b0d75c927173f2768307ed089e9b5a991c62d841fb51063f8aa1ed65a6.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Antigua And Barbuda": {
		"code": "AG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ag-b912d2a04490401a66441bdc4a702fdd0de83098dbc81e82dd7ba249d801d46a.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Argentina": {
		"code": "AR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ar-dc0a5ed2f626c59955a9ac31509fb91cced47ccc437dfae53d60a38005249afc.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Buenos Aires", "Catamarca", "Chaco", "Chubut", "Ciudad Autónoma de Buenos Aires", "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago Del Estero", "Tierra Del Fuego", "Tucumán"],
		"province_labels": {
			"Ciudad Autónoma de Buenos Aires": "Buenos Aires (Autonomous City)",
			"Buenos Aires": "Buenos Aires Province",
			"Catamarca": "Catamarca",
			"Chaco": "Chaco",
			"Chubut": "Chubut",
			"Córdoba": "Córdoba",
			"Corrientes": "Corrientes",
			"Entre Ríos": "Entre Ríos",
			"Formosa": "Formosa",
			"Jujuy": "Jujuy",
			"La Pampa": "La Pampa",
			"La Rioja": "La Rioja",
			"Mendoza": "Mendoza",
			"Misiones": "Misiones",
			"Neuquén": "Neuquén",
			"Río Negro": "Río Negro",
			"Salta": "Salta",
			"San Juan": "San Juan",
			"San Luis": "San Luis",
			"Santa Cruz": "Santa Cruz",
			"Santa Fe": "Santa Fe",
			"Santiago Del Estero": "Santiago del Estero",
			"Tierra Del Fuego": "Tierra del Fuego",
			"Tucumán": "Tucumán"
		},
		"province_codes": {
			"Buenos Aires": "B",
			"Catamarca": "K",
			"Chaco": "H",
			"Chubut": "U",
			"Ciudad Autónoma de Buenos Aires": "C",
			"Córdoba": "X",
			"Corrientes": "W",
			"Entre Ríos": "E",
			"Formosa": "P",
			"Jujuy": "Y",
			"La Pampa": "L",
			"La Rioja": "F",
			"Mendoza": "M",
			"Misiones": "N",
			"Neuquén": "Q",
			"Río Negro": "R",
			"Salta": "A",
			"San Juan": "J",
			"San Luis": "D",
			"Santa Cruz": "Z",
			"Santa Fe": "S",
			"Santiago Del Estero": "G",
			"Tierra Del Fuego": "V",
			"Tucumán": "T"
		},
		"province_alternate_names": {
			"Buenos Aires": null,
			"Catamarca": null,
			"Chaco": null,
			"Chubut": null,
			"Ciudad Autónoma de Buenos Aires": ["Ciudad Autonoma de Buenos Aires"],
			"Córdoba": ["Cordoba"],
			"Corrientes": null,
			"Entre Ríos": ["Entre Rios"],
			"Formosa": null,
			"Jujuy": null,
			"La Pampa": null,
			"La Rioja": null,
			"Mendoza": null,
			"Misiones": null,
			"Neuquén": ["Neuquen"],
			"Río Negro": ["Rio Negro"],
			"Salta": null,
			"San Juan": null,
			"San Luis": null,
			"Santa Cruz": null,
			"Santa Fe": null,
			"Santiago Del Estero": null,
			"Tierra Del Fuego": null,
			"Tucumán": ["Tucuman"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Armenia": {
		"code": "AM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/am-a9a3a54409e1d2bef4ea0c53a2b66dc7432254fd1580326d0e5a9fb7b18f5dac.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Aruba": {
		"code": "AW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/aw-3728e43855e00765ef2e40f197946649fde06f07a0fb33a124dbbdd94b793e25.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Ascension Island": {
		"code": "AC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ac-a56a872340f515db36b0ae3d9a9d16c9b39bea101e09a67ef6cba9169d8dce7f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Australia": {
		"code": "AU",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/au-13873c845dd7bb5655a50d96e393b1e5c08af1bd431f14a91d1d616cc46f192c.svg",
		"label": "State\/territory",
		"zip_label": "Postcode",
		"zip_placeholder": "Postcode",
		"zip_required": true,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "State\/territory",
		"provinces": ["Australian Capital Territory", "New South Wales", "Northern Territory", "Queensland", "South Australia", "Tasmania", "Victoria", "Western Australia"],
		"province_labels": {
			"Australian Capital Territory": "Australian Capital Territory",
			"New South Wales": "New South Wales",
			"Northern Territory": "Northern Territory",
			"Queensland": "Queensland",
			"South Australia": "South Australia",
			"Tasmania": "Tasmania",
			"Victoria": "Victoria",
			"Western Australia": "Western Australia"
		},
		"province_codes": {
			"Australian Capital Territory": "ACT",
			"New South Wales": "NSW",
			"Northern Territory": "NT",
			"Queensland": "QLD",
			"South Australia": "SA",
			"Tasmania": "TAS",
			"Victoria": "VIC",
			"Western Australia": "WA"
		},
		"province_alternate_names": {
			"Australian Capital Territory": null,
			"New South Wales": null,
			"Northern Territory": null,
			"Queensland": null,
			"South Australia": null,
			"Tasmania": null,
			"Victoria": null,
			"Western Australia": null
		},
		"checkout_zip_label": "Postcode",
		"checkout_zip_placeholder": "Postcode",
		"checkout_zone_label": "State\/territory",
		"checkout_zone_placeholder": "State\/territory"
	},
	"Austria": {
		"code": "AT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/at-dba77f84783603578980c0ae9801d617e27ff9acca6c45be81264a6b1d7df8b6.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Azerbaijan": {
		"code": "AZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/az-1085ba921a81e661397f00206ace09ae5719643cabee59ffa0674cfee62f2691.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bahamas": {
		"code": "BS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bs-bcc952e638d0e3de6f5e595b461b9629e6291330e73a81e857bb8645978dbb81.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bahrain": {
		"code": "BH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bh-0ca8149dfcdd96887846d04bfecd9f27e700ad5f7118a5385db4ba2cc3f16893.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bangladesh": {
		"code": "BD",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bd-e191b65efc29531da2809f91b04414a5487be88ebaaff3615b7a32da8c3d6c4e.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Barbados": {
		"code": "BB",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bb-ddc91bc3a20cfc3ea3a5618caf4bfc400aa6b25e131fb191f3c65e2cccd0def4.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Belarus": {
		"code": "BY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/by-bdf871401d4ab7ef2781e80954d67d108f7756b0d89ce2acfc216d4ae2c20d6b.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Belgium": {
		"code": "BE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/be-806dd1aa913ace4035ededeac4c1708e323909c7bf213b6b3e4245109aa8ba02.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Belize": {
		"code": "BZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bz-00a3d96a2ac76b7edaedcbc5c654b620e332c16774aac64fb00e290135dadec3.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Benin": {
		"code": "BJ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bj-6a2811523006a49b45b675777d43dba45e925136493ee3a03391a56a97fe9b8e.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bermuda": {
		"code": "BM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bm-8de9be055ea3598b4125e7cc07f6582582649174f35f2a5c43190bd1038f7dea.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bhutan": {
		"code": "BT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bt-2268a30a79e240aff419159cdd73e7b2098b36bcffbfd69ee03a17efaa8221be.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bolivia": {
		"code": "BO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bo-cfd48d23d6bfdb99c5d89fc035ebceae2e331b4802fbe531a38d7c6bf12772b9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bosnia And Herzegovina": {
		"code": "BA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ba-adf57e4f70d15236df96717a20c40aa56d8da5dc897c118fad2b61664642d5c0.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Botswana": {
		"code": "BW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bw-be023689fbd86bd7d217a975913a57418ea617c6d0c525078f556d3276f5b2a7.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bouvet Island": {
		"code": "BV",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bv-d605fb1b71590285722a2f8ceba677f258d528cd3cff5000ba64a9473c62bfa5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Brazil": {
		"code": "BR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/br-c0141f79405d80a7da70de1b45f6f9ce24e52f65c6c7b4dfa2e4b4728aa02660.svg",
		"label": "State",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "State",
		"provinces": ["Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", "Espírito Santo", "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", "Paraná", "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", "Rondônia", "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"],
		"province_labels": {
			"Acre": "Acre",
			"Alagoas": "Alagoas",
			"Amapá": "Amapá",
			"Amazonas": "Amazonas",
			"Bahia": "Bahia",
			"Ceará": "Ceará",
			"Espírito Santo": "Espírito Santo",
			"Distrito Federal": "Federal District",
			"Goiás": "Goiás",
			"Maranhão": "Maranhão",
			"Mato Grosso": "Mato Grosso",
			"Mato Grosso do Sul": "Mato Grosso do Sul",
			"Minas Gerais": "Minas Gerais",
			"Pará": "Pará",
			"Paraíba": "Paraíba",
			"Paraná": "Paraná",
			"Pernambuco": "Pernambuco",
			"Piauí": "Piauí",
			"Rio Grande do Norte": "Rio Grande do Norte",
			"Rio Grande do Sul": "Rio Grande do Sul",
			"Rio de Janeiro": "Rio de Janeiro",
			"Rondônia": "Rondônia",
			"Roraima": "Roraima",
			"Santa Catarina": "Santa Catarina",
			"São Paulo": "São Paulo",
			"Sergipe": "Sergipe",
			"Tocantins": "Tocantins"
		},
		"province_codes": {
			"Acre": "AC",
			"Alagoas": "AL",
			"Amapá": "AP",
			"Amazonas": "AM",
			"Bahia": "BA",
			"Ceará": "CE",
			"Distrito Federal": "DF",
			"Espírito Santo": "ES",
			"Goiás": "GO",
			"Maranhão": "MA",
			"Mato Grosso": "MT",
			"Mato Grosso do Sul": "MS",
			"Minas Gerais": "MG",
			"Pará": "PA",
			"Paraíba": "PB",
			"Paraná": "PR",
			"Pernambuco": "PE",
			"Piauí": "PI",
			"Rio de Janeiro": "RJ",
			"Rio Grande do Norte": "RN",
			"Rio Grande do Sul": "RS",
			"Rondônia": "RO",
			"Roraima": "RR",
			"Santa Catarina": "SC",
			"São Paulo": "SP",
			"Sergipe": "SE",
			"Tocantins": "TO"
		},
		"province_alternate_names": {
			"Acre": null,
			"Alagoas": null,
			"Amapá": ["Amapa"],
			"Amazonas": null,
			"Bahia": null,
			"Ceará": ["Ceara"],
			"Distrito Federal": null,
			"Espírito Santo": ["Espirito Santo"],
			"Goiás": ["Goias"],
			"Maranhão": ["Maranhao"],
			"Mato Grosso": null,
			"Mato Grosso do Sul": null,
			"Minas Gerais": null,
			"Pará": ["Para"],
			"Paraíba": ["Paraiba"],
			"Paraná": ["Parana"],
			"Pernambuco": null,
			"Piauí": ["Piaui"],
			"Rio de Janeiro": null,
			"Rio Grande do Norte": null,
			"Rio Grande do Sul": null,
			"Rondônia": ["Rondonia"],
			"Roraima": null,
			"Santa Catarina": null,
			"São Paulo": ["Sao Paulo"],
			"Sergipe": null,
			"Tocantins": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "State",
		"checkout_zone_placeholder": "State"
	},
	"British Indian Ocean Territory": {
		"code": "IO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/io-67bf3cf21d1e1e4c1c5245deb86cfb21d3791bd63f6a33a2adfd8d7f6c9d90a0.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Brunei": {
		"code": "BN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bn-554e32337da87f4f9bfded90be19893b36cc5d55361847836eb5d7d7db0ec468.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Bulgaria": {
		"code": "BG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bg-bbbd0544dea156ec45b7713db5e66f0efc768482f5a61ddf0cdc9a928f194661.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Burkina Faso": {
		"code": "BF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bf-66c389db1137ee09851de2e89d0b103f7917b5f055da530b23460eee7dac0e47.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Burundi": {
		"code": "BI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bi-78effa77b600a9a6f9b24bbffbc36b873250ad5af579b69925a81ca20840ac4b.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Cambodia": {
		"code": "KH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/kh-35c33da07e85eddd75f6fb715d54e8524be755b7b3dfa9fc20176c0b291f8022.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Canada": {
		"code": "CA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ca-0d78c57d795e496c1419de30c2af44b0d9b3cb96299cf879dcbf08cf9bbf41a4.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon"],
		"province_labels": {
			"Alberta": "Alberta",
			"British Columbia": "British Columbia",
			"Manitoba": "Manitoba",
			"New Brunswick": "New Brunswick",
			"Newfoundland and Labrador": "Newfoundland and Labrador",
			"Northwest Territories": "Northwest Territories",
			"Nova Scotia": "Nova Scotia",
			"Nunavut": "Nunavut",
			"Ontario": "Ontario",
			"Prince Edward Island": "Prince Edward Island",
			"Quebec": "Quebec",
			"Saskatchewan": "Saskatchewan",
			"Yukon": "Yukon"
		},
		"province_codes": {
			"Alberta": "AB",
			"British Columbia": "BC",
			"Manitoba": "MB",
			"New Brunswick": "NB",
			"Newfoundland and Labrador": "NL",
			"Northwest Territories": "NT",
			"Nova Scotia": "NS",
			"Nunavut": "NU",
			"Ontario": "ON",
			"Prince Edward Island": "PE",
			"Quebec": "QC",
			"Saskatchewan": "SK",
			"Yukon": "YT"
		},
		"province_alternate_names": {
			"Alberta": null,
			"British Columbia": null,
			"Manitoba": null,
			"New Brunswick": null,
			"Newfoundland and Labrador": ["Newfoundland"],
			"Northwest Territories": null,
			"Nova Scotia": null,
			"Nunavut": null,
			"Ontario": null,
			"Prince Edward Island": null,
			"Quebec": ["Québec"],
			"Saskatchewan": null,
			"Yukon": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Cape Verde": {
		"code": "CV",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cv-d0389eb5253d58f3b9135acf4690bd8112fcb64d943e1d96d37d49ad79d85329.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Caribbean Netherlands": {
		"code": "BQ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bq-a31b3f056508b2cc92348384b059e973ed934eb471064d7e98e95856a05c7f75.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Cayman Islands": {
		"code": "KY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ky-ed26b486d95eccb95f93b4ef6e052ce1a84c14a08c270909440f444def3a13d2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Central African Republic": {
		"code": "CF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cf-31abdd130dde03f612d658ff986e274b7aa7cea1cd24f287b24b363783ef3b10.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Chad": {
		"code": "TD",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/td-cf60b0660fef033f1e1c42303e90cd49c31595c755a9885499a0610b55cf32db.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Chile": {
		"code": "CL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cl-dce51159690a7a5026eec5515d46b167d5d025913a66adf0171ed3981c5bd1c1.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Arica and Parinacota", "Tarapacá", "Antofagasta", "Atacama", "Coquimbo", "Valparaíso", "Santiago", "O'Higgins", "Maule", "Ñuble", "Biobío", "Araucanía", "Los Ríos", "Los Lagos", "Aysén", "Magallanes"],
		"province_labels": {
			"Arica and Parinacota": "Arica y Parinacota",
			"Tarapacá": "Tarapacá",
			"Antofagasta": "Antofagasta",
			"Atacama": "Atacama",
			"Coquimbo": "Coquimbo",
			"Valparaíso": "Valparaíso",
			"Santiago": "Santiago Metropolitan",
			"O'Higgins": "Libertador General Bernardo O’Higgins",
			"Maule": "Maule",
			"Ñuble": "Ñuble",
			"Biobío": "Bío Bío",
			"Araucanía": "Araucanía",
			"Los Ríos": "Los Ríos",
			"Los Lagos": "Los Lagos",
			"Aysén": "Aysén",
			"Magallanes": "Magallanes Region"
		},
		"province_codes": {
			"Arica and Parinacota": "AP",
			"Tarapacá": "TA",
			"Antofagasta": "AN",
			"Atacama": "AT",
			"Coquimbo": "CO",
			"Valparaíso": "VS",
			"Santiago": "RM",
			"O'Higgins": "LI",
			"Maule": "ML",
			"Ñuble": "NB",
			"Biobío": "BI",
			"Araucanía": "AR",
			"Los Ríos": "LR",
			"Los Lagos": "LL",
			"Aysén": "AI",
			"Magallanes": "MA"
		},
		"province_alternate_names": {
			"Arica and Parinacota": ["Arica y Parinacota", "Región de Arica y Parinacota", "Region de Arica y Parinacota"],
			"Tarapacá": ["Tarapaca", "Región de Tarapacá", "Region de Tarapaca"],
			"Antofagasta": ["Región de Antofagasta", "Region de Antofagasta"],
			"Atacama": ["Región de Atacama", "Region de Atacama"],
			"Coquimbo": ["Región de Coquimbo", "Region de Coquimbo"],
			"Valparaíso": ["Valparaiso", "Región de Valparaíso", "Region de Valparaiso"],
			"Santiago": ["Región Metropolitana", "Region Metropolitana", "Región Metropolitana de Santiago", "Region Metropolitana de Santiago"],
			"O'Higgins": ["Región del Libertador General Bernardo O'Higgins", "Region del Libertador General Bernardo O'Higgins"],
			"Maule": ["Región del Maule", "Region del Maule"],
			"Ñuble": ["Nuble", "Región de Ñuble", "Region de Nuble"],
			"Biobío": ["Biobio", "Región del Biobío", "Region del Biobio"],
			"Araucanía": ["Araucania", "Región de La Araucanía", "Region de La Araucania"],
			"Los Ríos": ["Los Rios", "Región de Los Ríos", "Region de Los Rios"],
			"Los Lagos": ["Región de Los Lagos", "Region de Los Lagos"],
			"Aysén": ["Aysen", "Región Aysén del General Carlos Ibáñez del Campo", "Region Aysen del General Carlos Ibanez del Campo"],
			"Magallanes": ["Región de Magallanes y de la Antártica Chilena", "Region de Magallanes y de la Antartica Chilena"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"China": {
		"code": "CN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cn-2153644e96e86a433f6157a6a75327d8f5b74c72e3b9c744bb9c53b125c15143.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong", "Guangxi", "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan", "Hubei", "Hunan", "Inner Mongolia", "Jiangsu", "Jiangxi", "Jilin", "Liaoning", "Ningxia", "Qinghai", "Shaanxi", "Shandong", "Shanghai", "Shanxi", "Sichuan", "Tianjin", "Xinjiang", "Xizang", "Yunnan", "Zhejiang"],
		"province_labels": {
			"Anhui": "Anhui",
			"Beijing": "Beijing",
			"Chongqing": "Chongqing",
			"Fujian": "Fujian",
			"Gansu": "Gansu",
			"Guangdong": "Guangdong",
			"Guangxi": "Guangxi",
			"Guizhou": "Guizhou",
			"Hainan": "Hainan",
			"Hebei": "Hebei",
			"Heilongjiang": "Heilongjiang",
			"Henan": "Henan",
			"Hubei": "Hubei",
			"Hunan": "Hunan",
			"Inner Mongolia": "Inner Mongolia",
			"Jiangsu": "Jiangsu",
			"Jiangxi": "Jiangxi",
			"Jilin": "Jilin",
			"Liaoning": "Liaoning",
			"Ningxia": "Ningxia",
			"Qinghai": "Qinghai",
			"Shaanxi": "Shaanxi",
			"Shandong": "Shandong",
			"Shanghai": "Shanghai",
			"Shanxi": "Shanxi",
			"Sichuan": "Sichuan",
			"Tianjin": "Tianjin",
			"Xizang": "Tibet",
			"Xinjiang": "Xinjiang",
			"Yunnan": "Yunnan",
			"Zhejiang": "Zhejiang"
		},
		"province_codes": {
			"Anhui": "AH",
			"Beijing": "BJ",
			"Chongqing": "CQ",
			"Fujian": "FJ",
			"Gansu": "GS",
			"Guangdong": "GD",
			"Guangxi": "GX",
			"Guizhou": "GZ",
			"Hainan": "HI",
			"Hebei": "HE",
			"Heilongjiang": "HL",
			"Henan": "HA",
			"Hubei": "HB",
			"Hunan": "HN",
			"Inner Mongolia": "NM",
			"Jiangsu": "JS",
			"Jiangxi": "JX",
			"Jilin": "JL",
			"Liaoning": "LN",
			"Ningxia": "NX",
			"Qinghai": "QH",
			"Shaanxi": "SN",
			"Shandong": "SD",
			"Shanghai": "SH",
			"Shanxi": "SX",
			"Sichuan": "SC",
			"Tianjin": "TJ",
			"Xinjiang": "XJ",
			"Xizang": "YZ",
			"Yunnan": "YN",
			"Zhejiang": "ZJ"
		},
		"province_alternate_names": {
			"Anhui": ["安徽"],
			"Beijing": ["北京"],
			"Chongqing": ["重庆"],
			"Fujian": ["福建"],
			"Gansu": ["甘肃"],
			"Guangdong": ["广东"],
			"Guangxi": ["广西"],
			"Guizhou": ["贵州"],
			"Hainan": ["海南"],
			"Hebei": ["河北"],
			"Heilongjiang": ["黑龙江"],
			"Henan": ["河南"],
			"Hubei": ["湖北"],
			"Hunan": ["湖南"],
			"Inner Mongolia": ["内蒙古", "Nei Mongol"],
			"Jiangsu": ["江苏"],
			"Jiangxi": ["江西"],
			"Jilin": ["吉林"],
			"Liaoning": ["辽宁"],
			"Ningxia": ["宁夏"],
			"Qinghai": ["青海"],
			"Shaanxi": ["陕西"],
			"Shandong": ["山东"],
			"Shanghai": ["上海"],
			"Shanxi": ["山西"],
			"Sichuan": ["四川"],
			"Tianjin": ["天津"],
			"Xinjiang": ["新疆"],
			"Xizang": ["西藏", "Tibet"],
			"Yunnan": ["云南"],
			"Zhejiang": ["浙江"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Christmas Island": {
		"code": "CX",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cx-b88b54564b2548cf3372a7d5765c326807c5f12bff8188847f1e9cf0eff9f4ce.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Cocos (Keeling) Islands": {
		"code": "CC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cc-5a2493732775d48804c70cd39578c71af089cc4c4ce84c995a9d0a0f52ad0ba2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Colombia": {
		"code": "CO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/co-a37a6bc1fe59000adbe09ea8ac216e2b66ba728742e119349bab34d1fd1b3c11.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Amazonas", "Antioquia", "Arauca", "Atlántico", "Bogotá, D.C.", "Bolívar", "Boyacá", "Caldas", "Caquetá", "Casanare", "Cauca", "Cesar", "Chocó", "Córdoba", "Cundinamarca", "Guainía", "Guaviare", "Huila", "La Guajira", "Magdalena", "Meta", "Nariño", "Norte de Santander", "Putumayo", "Quindío", "Risaralda", "San Andrés, Providencia y Santa Catalina", "Santander", "Sucre", "Tolima", "Valle del Cauca", "Vaupés", "Vichada"],
		"province_labels": {
			"Bogotá, D.C.": "Capital District",
			"Amazonas": "Amazonas",
			"Antioquia": "Antioquia",
			"Arauca": "Arauca",
			"Atlántico": "Atlántico",
			"Bolívar": "Bolívar",
			"Boyacá": "Boyacá",
			"Caldas": "Caldas",
			"Caquetá": "Caquetá",
			"Casanare": "Casanare",
			"Cauca": "Cauca",
			"Cesar": "Cesar",
			"Chocó": "Chocó",
			"Córdoba": "Córdoba",
			"Cundinamarca": "Cundinamarca",
			"Guainía": "Guainía",
			"Guaviare": "Guaviare",
			"Huila": "Huila",
			"La Guajira": "La Guajira",
			"Magdalena": "Magdalena",
			"Meta": "Meta",
			"Nariño": "Nariño",
			"Norte de Santander": "Norte de Santander",
			"Putumayo": "Putumayo",
			"Quindío": "Quindío",
			"Risaralda": "Risaralda",
			"San Andrés, Providencia y Santa Catalina": "San Andrés \u0026 Providencia",
			"Santander": "Santander",
			"Sucre": "Sucre",
			"Tolima": "Tolima",
			"Valle del Cauca": "Valle del Cauca",
			"Vaupés": "Vaupés",
			"Vichada": "Vichada"
		},
		"province_codes": {
			"Amazonas": "AMA",
			"Antioquia": "ANT",
			"Arauca": "ARA",
			"Atlántico": "ATL",
			"Bogotá, D.C.": "DC",
			"Bolívar": "BOL",
			"Boyacá": "BOY",
			"Caldas": "CAL",
			"Caquetá": "CAQ",
			"Casanare": "CAS",
			"Cauca": "CAU",
			"Cesar": "CES",
			"Chocó": "CHO",
			"Córdoba": "COR",
			"Cundinamarca": "CUN",
			"Guainía": "GUA",
			"Guaviare": "GUV",
			"Huila": "HUI",
			"La Guajira": "LAG",
			"Magdalena": "MAG",
			"Meta": "MET",
			"Nariño": "NAR",
			"Norte de Santander": "NSA",
			"Putumayo": "PUT",
			"Quindío": "QUI",
			"Risaralda": "RIS",
			"San Andrés, Providencia y Santa Catalina": "SAP",
			"Santander": "SAN",
			"Sucre": "SUC",
			"Tolima": "TOL",
			"Valle del Cauca": "VAC",
			"Vaupés": "VAU",
			"Vichada": "VID"
		},
		"province_alternate_names": {
			"Amazonas": null,
			"Antioquia": null,
			"Arauca": null,
			"Atlántico": ["Atlantico"],
			"Bogotá, D.C.": ["Bogota, D.C.", "Bogotá", "Bogota", "Capital District", "Distrito Capital de Bogotá", "Distrito Capital de Bogota"],
			"Bolívar": ["Bolivar"],
			"Boyacá": ["Boyaca"],
			"Caldas": null,
			"Caquetá": ["Caqueta"],
			"Casanare": null,
			"Cauca": null,
			"Cesar": null,
			"Chocó": ["Choco"],
			"Córdoba": ["Cordoba"],
			"Cundinamarca": null,
			"Guainía": ["Guainia"],
			"Guaviare": null,
			"Huila": null,
			"La Guajira": null,
			"Magdalena": null,
			"Meta": null,
			"Nariño": ["Narino"],
			"Norte de Santander": null,
			"Putumayo": null,
			"Quindío": ["Quindio"],
			"Risaralda": null,
			"San Andrés, Providencia y Santa Catalina": ["San Andres, Providencia y Santa Catalina", "San Andrés y Providencia", "San Andres y Providencia"],
			"Santander": null,
			"Sucre": null,
			"Tolima": null,
			"Valle del Cauca": null,
			"Vaupés": ["Vaupes"],
			"Vichada": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Comoros": {
		"code": "KM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/km-2976c3376cf684fa5901f144705e758b85a218ac83842b9b1db49cba5be381a0.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Congo": {
		"code": "CG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cg-2b740c3fdc86df76a4f4ead09ccc6664e0163137207bbb61e7b57e0d4c9be547.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Congo, The Democratic Republic Of The": {
		"code": "CD",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cd-ae468a43e22f29834d1cf7ec146de566208cd4c080b7e41f89da062869286bb2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Cook Islands": {
		"code": "CK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ck-8e6b1d3b6c387fadb92652588fee211d070cd282c0aa3fb0fbbd9e4b9ccbb542.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Costa Rica": {
		"code": "CR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cr-7f230d3c663b681efbe66f7c17cf462b8e4654df5b2dc9ed2d4c042481bd6303.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Croatia": {
		"code": "HR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/hr-b0f2f2fb13f5432879442bcae39e125a360f552dd02fe58c9a48fa44a4a9afca.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Cuba": {
		"code": "CU",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cu-aa4bcfbbe8e82a584fe8350cf0d88f69466686babcb4576dbf93b64be9537d07.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Curaçao": {
		"code": "CW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cw-8321fddf0fbdd74f630838df754e17b329b19e18a0a5eee518d2b5c866f8a0f9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Cyprus": {
		"code": "CY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cy-2fc766b0049ba792171dd5c20731609ab879a457a0657167d3a9827a2189bd4e.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Czech Republic": {
		"code": "CZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cz-c7cf8a8de7e5f6bc9ae2f80f1d99272031c8ea2841ca79de86476ef9ae4a901b.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Côte d'Ivoire": {
		"code": "CI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ci-03c70c3f8d18a25facb7c9db9704b9318bd388453bd3b5fc68e8e11a708e978f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Denmark": {
		"code": "DK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/dk-d15b90eddd91956b7de55019da0479b09a3342d998f38acd5847d3c0be528eaa.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Djibouti": {
		"code": "DJ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/dj-9fdbecaccd3869bac5684ab654f4d2adfad0cb8670b593d59792c1e08db9c8e2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Dominica": {
		"code": "DM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/dm-c9dc4a0b36fe5c2c0f18a2d13d6f44239fd9f495cd89558cac8645393a64f5b1.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Dominican Republic": {
		"code": "DO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/do-cac884ee8edbc3a89dcae1494b2bdef504ab78c590f7075cc7dbb5fb1c2b6cf6.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Ecuador": {
		"code": "EC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ec-c596bab16fe217175364df9f15750a6feccab34afdaa8c8c423e3094e06c62a3.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Egypt": {
		"code": "EG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/eg-5b2eda03efba7ebfb1c548ca444b4b406b8f80d1b1e68935de595f7ef9b1a5af.svg",
		"label": "Governorate",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Governorate",
		"provinces": ["6th of October", "Al Sharqia", "Alexandria", "Aswan", "Asyut", "Beheira", "Beni Suef", "Cairo", "Dakahlia", "Damietta", "Faiyum", "Gharbia", "Giza", "Helwan", "Ismailia", "Kafr el-Sheikh", "Luxor", "Matrouh", "Minya", "Monufia", "New Valley", "North Sinai", "Port Said", "Qalyubia", "Qena", "Red Sea", "Sohag", "South Sinai", "Suez"],
		"province_labels": {
			"6th of October": "6th of October",
			"Al Sharqia": "Al Sharqia",
			"Alexandria": "Alexandria",
			"Aswan": "Aswan",
			"Asyut": "Asyut",
			"Beheira": "Beheira",
			"Beni Suef": "Beni Suef",
			"Cairo": "Cairo",
			"Dakahlia": "Dakahlia",
			"Damietta": "Damietta",
			"Faiyum": "Faiyum",
			"Gharbia": "Gharbia",
			"Giza": "Giza",
			"Helwan": "Helwan",
			"Ismailia": "Ismailia",
			"Kafr el-Sheikh": "Kafr el-Sheikh",
			"Luxor": "Luxor",
			"Matrouh": "Matrouh",
			"Minya": "Minya",
			"Monufia": "Monufia",
			"New Valley": "New Valley",
			"North Sinai": "North Sinai",
			"Port Said": "Port Said",
			"Qalyubia": "Qalyubia",
			"Qena": "Qena",
			"Red Sea": "Red Sea",
			"Sohag": "Sohag",
			"South Sinai": "South Sinai",
			"Suez": "Suez"
		},
		"province_codes": {
			"6th of October": "SU",
			"Al Sharqia": "SHR",
			"Alexandria": "ALX",
			"Aswan": "ASN",
			"Asyut": "AST",
			"Beheira": "BH",
			"Beni Suef": "BNS",
			"Cairo": "C",
			"Dakahlia": "DK",
			"Damietta": "DT",
			"Faiyum": "FYM",
			"Gharbia": "GH",
			"Giza": "GZ",
			"Helwan": "HU",
			"Ismailia": "IS",
			"Kafr el-Sheikh": "KFS",
			"Luxor": "LX",
			"Matrouh": "MT",
			"Minya": "MN",
			"Monufia": "MNF",
			"New Valley": "WAD",
			"North Sinai": "SIN",
			"Port Said": "PTS",
			"Qalyubia": "KB",
			"Qena": "KN",
			"Red Sea": "BA",
			"Sohag": "SHG",
			"South Sinai": "JS",
			"Suez": "SUZ"
		},
		"province_alternate_names": {
			"6th of October": ["As Sādis min Uktūbar", "As Sadis min Uktubar"],
			"Al Sharqia": ["Ash Sharqīyah", "Ash Sharqiyah"],
			"Alexandria": ["Al Iskandarīyah", "Al Iskandariyah"],
			"Aswan": ["Aswān"],
			"Asyut": ["Asyūţ"],
			"Beheira": ["Al Buḩayrah", "Al Buayrah"],
			"Beni Suef": ["Banī Suwayf", "Bani Suwayf"],
			"Cairo": ["Al Qāhirah", "Al Qahirah"],
			"Dakahlia": ["Ad Daqahlīyah", "Ad Daqahliyah"],
			"Damietta": ["Dumyāţ", "Dumyat"],
			"Faiyum": ["Al Fayyūm", "Al Fayyum"],
			"Gharbia": ["Al Gharbīyah", "Al Gharbiyah"],
			"Giza": ["Al Jīzah", "Al Jizah"],
			"Helwan": ["Ḩulwān", "ulwan"],
			"Ismailia": ["Al Ismāٰīlīyah", "Al Ismailiyah"],
			"Kafr el-Sheikh": ["Kafr ash Shaykh"],
			"Luxor": ["Al Uqşur", "Al Uqsur"],
			"Matrouh": ["Maţrūḩ", "Matru"],
			"Minya": ["Al Minyā", "Al Minya"],
			"Monufia": ["Al Minūfīyah", "Al Minufiyah"],
			"New Valley": ["Al Wādī al Jadīd", "Al Wadi al Jadid"],
			"North Sinai": ["Shamāl Sīnā", "Shamal Sina"],
			"Port Said": ["Būr Saٰīd", "Bur Said"],
			"Qalyubia": ["Al Qalyūbīyah", "Al Qalyubiyah"],
			"Qena": ["Qinā", "Qina"],
			"Red Sea": ["Al Baḩr al Aḩmar", "Al Bar al Amar"],
			"Sohag": ["Sūhāj", "Suhaj"],
			"South Sinai": ["Janūb Sīnā", "Janub Sina"],
			"Suez": ["As Suways"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Governorate",
		"checkout_zone_placeholder": "Governorate"
	},
	"El Salvador": {
		"code": "SV",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sv-006db52e2d7a1c487539ae6c1e78e3155566ee2f7929c1e03223e6b737ac6ab9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Equatorial Guinea": {
		"code": "GQ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gq-9c100a177dc61bad19c2a062b125adcf18666ac150313b441ed1e3718d0e47ae.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Eritrea": {
		"code": "ER",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/er-b6b91d43ee051cc4d28acdabdeede03d0459fae3b5c58a0cece76ff97ebf6a0b.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Estonia": {
		"code": "EE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ee-cf276fa448f6bc2db954c646d66ad95094b3196c1ba3eb4c2cf4de9a5fec8440.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Eswatini": {
		"code": "SZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sz-92d32ce32d08e4c21ad37388cc11bf6f99250b5ae5ec0fc152b9cefe09447715.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Ethiopia": {
		"code": "ET",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/et-88bc1ebc97fb568afd75c3d34ce56c3c689134d8c3bdd42c4bcd1c33ded0e622.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Falkland Islands (Malvinas)": {
		"code": "FK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/fk-b035f39f06bfca7c5ddb552910884b207c348675be064d1a9acb38a09fd46537.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Faroe Islands": {
		"code": "FO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/fo-ba7ea8e10960ce78eb1a627faba52b8efcdd937bcf83acfb35f54635d79639c3.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Fiji": {
		"code": "FJ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/fj-95a085e87c958f72664e1048cc0cf71b3a4e29bfccd6f3a8186f955c3766ca13.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Finland": {
		"code": "FI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/fi-8c4f1b318e181809c96b510c9d4c27b0b0146e9e01b2a0914c5bf374d11e2886.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"France": {
		"code": "FR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/fr-10d09cbc2a8b2219da141bbacc940ec8f45a55b36b0dd8f92d07c6c93331f85f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"French Guiana": {
		"code": "GF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gf-e5758afce89dedfa86013c413f6b1770f6b6f29bbdfcf8c9ec67c0727a8dbebe.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"French Polynesia": {
		"code": "PF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pf-5aeb49aac473f8e2718d7f668538451a52b6040c0f2b5c49dc0459e098ae6dbd.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"French Southern Territories": {
		"code": "TF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tf-b25e7bbb1fe82f1d734fe3d40f3cbd2291d2a72cbc2c3af37da4118a3ec9b974.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Gabon": {
		"code": "GA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ga-4c7cdf1af94111f99e53c48e3af3326180a9a03b71d032f683bfdd74d116a066.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Gambia": {
		"code": "GM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gm-242e323d8c81ae460bd10e89d45d718b995451c6ab77f3833ae7248cbca76e0e.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Georgia": {
		"code": "GE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ge-7abbfeb26a91671f1e6f6f1ac9bbe7ff98315929241ae5aae4d891244c4fc1d9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Germany": {
		"code": "DE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/de-cb66769cd2af2a363f35a0f1da6c7a5c584c35a6391f2dd4878c6f9005f3ecb6.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Ghana": {
		"code": "GH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gh-52bd561ba8efc114ad5eb0cdeeca772dc097457b480ecd1e04fb44fc38f24643.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Gibraltar": {
		"code": "GI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gi-fcca3661db81ea804e6e295390699f9b12381cdeb9e89e6452844a9f47326b23.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Greece": {
		"code": "GR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gr-8df55bbaf97f7ec255c4edd00172fa549fda7c6b0f805a3f5bfda56244e4064d.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Greenland": {
		"code": "GL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gl-95144c3e191cd567fee82bf0f223f4f5729a2b7a9d9115ab713411c61fb59a12.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Grenada": {
		"code": "GD",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gd-b00fe4a1299babda4b4926408d6335e9de55ee2a43906a80ca5092a2f7bba53b.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Guadeloupe": {
		"code": "GP",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gp-10d09cbc2a8b2219da141bbacc940ec8f45a55b36b0dd8f92d07c6c93331f85f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Guatemala": {
		"code": "GT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gt-6b7c52001bc25b596e05cc2730f93d6976271bd7fda1667a0a6171573a5eb0cf.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Alta Verapaz", "Baja Verapaz", "Chimaltenango", "Chiquimula", "El Progreso", "Escuintla", "Guatemala", "Huehuetenango", "Izabal", "Jalapa", "Jutiapa", "Petén", "Quetzaltenango", "Quiché", "Retalhuleu", "Sacatepéquez", "San Marcos", "Santa Rosa", "Sololá", "Suchitepéquez", "Totonicapán", "Zacapa"],
		"province_labels": {
			"Alta Verapaz": "Alta Verapaz",
			"Baja Verapaz": "Baja Verapaz",
			"Chimaltenango": "Chimaltenango",
			"Chiquimula": "Chiquimula",
			"El Progreso": "El Progreso",
			"Escuintla": "Escuintla",
			"Guatemala": "Guatemala",
			"Huehuetenango": "Huehuetenango",
			"Izabal": "Izabal",
			"Jalapa": "Jalapa",
			"Jutiapa": "Jutiapa",
			"Petén": "Petén",
			"Quetzaltenango": "Quetzaltenango",
			"Quiché": "Quiché",
			"Retalhuleu": "Retalhuleu",
			"Sacatepéquez": "Sacatepéquez",
			"San Marcos": "San Marcos",
			"Santa Rosa": "Santa Rosa",
			"Sololá": "Sololá",
			"Suchitepéquez": "Suchitepéquez",
			"Totonicapán": "Totonicapán",
			"Zacapa": "Zacapa"
		},
		"province_codes": {
			"Alta Verapaz": "AVE",
			"Baja Verapaz": "BVE",
			"Chimaltenango": "CMT",
			"Chiquimula": "CQM",
			"El Progreso": "EPR",
			"Escuintla": "ESC",
			"Guatemala": "GUA",
			"Huehuetenango": "HUE",
			"Izabal": "IZA",
			"Jalapa": "JAL",
			"Jutiapa": "JUT",
			"Petén": "PET",
			"Quetzaltenango": "QUE",
			"Quiché": "QUI",
			"Retalhuleu": "RET",
			"Sacatepéquez": "SAC",
			"San Marcos": "SMA",
			"Santa Rosa": "SRO",
			"Sololá": "SOL",
			"Suchitepéquez": "SUC",
			"Totonicapán": "TOT",
			"Zacapa": "ZAC"
		},
		"province_alternate_names": {
			"Alta Verapaz": null,
			"Baja Verapaz": null,
			"Chimaltenango": null,
			"Chiquimula": null,
			"El Progreso": null,
			"Escuintla": null,
			"Guatemala": null,
			"Huehuetenango": null,
			"Izabal": null,
			"Jalapa": null,
			"Jutiapa": null,
			"Petén": ["Peten"],
			"Quetzaltenango": null,
			"Quiché": ["Quiche"],
			"Retalhuleu": null,
			"Sacatepéquez": ["Sacatepequez"],
			"San Marcos": null,
			"Santa Rosa": null,
			"Sololá": ["Solola"],
			"Suchitepéquez": ["Suchitepequez"],
			"Totonicapán": ["Totonicapan"],
			"Zacapa": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Guernsey": {
		"code": "GG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gg-df748401d5d3ec0c564ccf54ff192a6bffb34e6af25dae6a379639269eedc2eb.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Guinea": {
		"code": "GN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gn-52a9dc98e6122cd57cc813c4da100240ab7814f724a66b0954a0c34c145a4ddf.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Guinea Bissau": {
		"code": "GW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gw-68a5ffd842fed63a8ffcd151180b4b19155ab7cd13987cd3a31d86f6ac51763a.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Guyana": {
		"code": "GY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gy-da90cfa08127e416de3191deecfc4347da6431b60583c685e424aba6be5681e9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Haiti": {
		"code": "HT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ht-ce3ae14b69acfda0e166b359341be5344b484d47531a517247f3871277aaee48.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Heard Island And Mcdonald Islands": {
		"code": "HM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/hm-e1cd313272f5073da89c733dce47268634c84d0a7656a8593446dda2682594a4.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Holy See (Vatican City State)": {
		"code": "VA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/va-5fb5774b8de2849de4208dceaeef0f1705f4dbd5de11c024285f3cb174c47c65.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Honduras": {
		"code": "HN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/hn-3c0b0aaff2299cdcb42f8c8d39aec9c24831332914032cedb89f09d52d2dc0a6.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Hong Kong": {
		"code": "HK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/hk-6eedf73300bf96c4ffb2528905eb62da02456b532d08545de303aa55cd0cf057.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cs",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Hong Kong Island", "Kowloon", "New Territories"],
		"province_labels": {
			"Hong Kong Island": "Hong Kong Island",
			"Kowloon": "Kowloon",
			"New Territories": "New Territories"
		},
		"province_codes": {
			"Hong Kong Island": "HK",
			"Kowloon": "KL",
			"New Territories": "NT"
		},
		"province_alternate_names": {
			"Hong Kong Island": ["Hong Kong Province", "Hong Kong", "香港", "香港島"],
			"Kowloon": ["九龍"],
			"New Territories": ["新界"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Hungary": {
		"code": "HU",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/hu-5b54a899b7a3fd5dfbd4dbe9ed320af2c58162267c9c16cf89ae1fa92d9bb38f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Iceland": {
		"code": "IS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/is-7d6167f029623e57ee7b030708b18ae267ff961a4f829b37cbc246a0c9311474.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"India": {
		"code": "IN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/in-0e84df729f1dd51112bd51e4523e7f5416aa65ade27b7f66056bcb13e1f933c4.svg",
		"label": "State",
		"zip_label": "PIN code",
		"zip_placeholder": "PIN code",
		"zip_required": true,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "State",
		"provinces": ["Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli", "Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"],
		"province_labels": {
			"Andaman and Nicobar Islands": "Andaman and Nicobar Islands",
			"Andhra Pradesh": "Andhra Pradesh",
			"Arunachal Pradesh": "Arunachal Pradesh",
			"Assam": "Assam",
			"Bihar": "Bihar",
			"Chandigarh": "Chandigarh",
			"Chhattisgarh": "Chhattisgarh",
			"Dadra and Nagar Haveli": "Dadra and Nagar Haveli",
			"Daman and Diu": "Daman and Diu",
			"Delhi": "Delhi",
			"Goa": "Goa",
			"Gujarat": "Gujarat",
			"Haryana": "Haryana",
			"Himachal Pradesh": "Himachal Pradesh",
			"Jammu and Kashmir": "Jammu and Kashmir",
			"Jharkhand": "Jharkhand",
			"Karnataka": "Karnataka",
			"Kerala": "Kerala",
			"Ladakh": "Ladakh",
			"Lakshadweep": "Lakshadweep",
			"Madhya Pradesh": "Madhya Pradesh",
			"Maharashtra": "Maharashtra",
			"Manipur": "Manipur",
			"Meghalaya": "Meghalaya",
			"Mizoram": "Mizoram",
			"Nagaland": "Nagaland",
			"Odisha": "Odisha",
			"Puducherry": "Puducherry",
			"Punjab": "Punjab",
			"Rajasthan": "Rajasthan",
			"Sikkim": "Sikkim",
			"Tamil Nadu": "Tamil Nadu",
			"Telangana": "Telangana",
			"Tripura": "Tripura",
			"Uttar Pradesh": "Uttar Pradesh",
			"Uttarakhand": "Uttarakhand",
			"West Bengal": "West Bengal"
		},
		"province_codes": {
			"Andaman and Nicobar Islands": "AN",
			"Andhra Pradesh": "AP",
			"Arunachal Pradesh": "AR",
			"Assam": "AS",
			"Bihar": "BR",
			"Chandigarh": "CH",
			"Chhattisgarh": "CG",
			"Dadra and Nagar Haveli": "DN",
			"Daman and Diu": "DD",
			"Delhi": "DL",
			"Goa": "GA",
			"Gujarat": "GJ",
			"Haryana": "HR",
			"Himachal Pradesh": "HP",
			"Jammu and Kashmir": "JK",
			"Jharkhand": "JH",
			"Karnataka": "KA",
			"Kerala": "KL",
			"Ladakh": "LA",
			"Lakshadweep": "LD",
			"Madhya Pradesh": "MP",
			"Maharashtra": "MH",
			"Manipur": "MN",
			"Meghalaya": "ML",
			"Mizoram": "MZ",
			"Nagaland": "NL",
			"Odisha": "OR",
			"Puducherry": "PY",
			"Punjab": "PB",
			"Rajasthan": "RJ",
			"Sikkim": "SK",
			"Tamil Nadu": "TN",
			"Telangana": "TS",
			"Tripura": "TR",
			"Uttar Pradesh": "UP",
			"Uttarakhand": "UK",
			"West Bengal": "WB"
		},
		"province_alternate_names": {
			"Andaman and Nicobar Islands": ["Andaman and Nicobar"],
			"Andhra Pradesh": null,
			"Arunachal Pradesh": null,
			"Assam": null,
			"Bihar": null,
			"Chandigarh": null,
			"Chhattisgarh": ["Chattisgarh", "CT"],
			"Dadra and Nagar Haveli": null,
			"Daman and Diu": null,
			"Delhi": null,
			"Goa": null,
			"Gujarat": null,
			"Haryana": null,
			"Himachal Pradesh": null,
			"Jammu and Kashmir": null,
			"Jharkhand": null,
			"Karnataka": null,
			"Kerala": null,
			"Ladakh": null,
			"Lakshadweep": null,
			"Madhya Pradesh": null,
			"Maharashtra": null,
			"Manipur": null,
			"Meghalaya": null,
			"Mizoram": null,
			"Nagaland": null,
			"Odisha": ["OD", "Orissa"],
			"Puducherry": null,
			"Punjab": null,
			"Rajasthan": null,
			"Sikkim": null,
			"Tamil Nadu": null,
			"Telangana": null,
			"Tripura": null,
			"Uttar Pradesh": null,
			"Uttarakhand": null,
			"West Bengal": null
		},
		"checkout_zip_label": "PIN code",
		"checkout_zip_placeholder": "PIN code",
		"checkout_zone_label": "State",
		"checkout_zone_placeholder": "State"
	},
	"Indonesia": {
		"code": "ID",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/id-af8ae4bcec649b476a512871baf313544722c3dc3b9336e6bc15496e1e158cfb.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_sp_c",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Aceh", "Bali", "Bangka Belitung", "Banten", "Bengkulu", "Gorontalo", "Jakarta", "Jambi", "Jawa Barat", "Jawa Tengah", "Jawa Timur", "Kalimantan Barat", "Kalimantan Selatan", "Kalimantan Tengah", "Kalimantan Timur", "Kalimantan Utara", "Kepulauan Riau", "Lampung", "Maluku", "Maluku Utara", "North Sumatra", "Nusa Tenggara Barat", "Nusa Tenggara Timur", "Papua", "Papua Barat", "Riau", "South Sumatra", "Sulawesi Barat", "Sulawesi Selatan", "Sulawesi Tengah", "Sulawesi Tenggara", "Sulawesi Utara", "West Sumatra", "Yogyakarta"],
		"province_labels": {
			"Aceh": "Aceh",
			"Bali": "Bali",
			"Bangka Belitung": "Bangka–Belitung Islands",
			"Banten": "Banten",
			"Bengkulu": "Bengkulu",
			"Jawa Tengah": "Central Java",
			"Kalimantan Tengah": "Central Kalimantan",
			"Sulawesi Tengah": "Central Sulawesi",
			"Jawa Timur": "East Java",
			"Kalimantan Timur": "East Kalimantan",
			"Nusa Tenggara Timur": "East Nusa Tenggara",
			"Gorontalo": "Gorontalo",
			"Jakarta": "Jakarta",
			"Jambi": "Jambi",
			"Lampung": "Lampung",
			"Maluku": "Maluku",
			"Kalimantan Utara": "North Kalimantan",
			"Maluku Utara": "North Maluku",
			"Sulawesi Utara": "North Sulawesi",
			"North Sumatra": "North Sumatra",
			"Papua": "Papua",
			"Riau": "Riau",
			"Kepulauan Riau": "Riau Islands",
			"Kalimantan Selatan": "South Kalimantan",
			"Sulawesi Selatan": "South Sulawesi",
			"South Sumatra": "South Sumatra",
			"Sulawesi Tenggara": "Southeast Sulawesi",
			"Jawa Barat": "West Java",
			"Kalimantan Barat": "West Kalimantan",
			"Nusa Tenggara Barat": "West Nusa Tenggara",
			"Papua Barat": "West Papua",
			"Sulawesi Barat": "West Sulawesi",
			"West Sumatra": "West Sumatra",
			"Yogyakarta": "Yogyakarta"
		},
		"province_codes": {
			"Aceh": "AC",
			"Bali": "BA",
			"Bangka Belitung": "BB",
			"Banten": "BT",
			"Bengkulu": "BE",
			"Gorontalo": "GO",
			"Jakarta": "JK",
			"Jambi": "JA",
			"Jawa Barat": "JB",
			"Jawa Tengah": "JT",
			"Jawa Timur": "JI",
			"Kalimantan Barat": "KB",
			"Kalimantan Selatan": "KS",
			"Kalimantan Tengah": "KT",
			"Kalimantan Timur": "KI",
			"Kalimantan Utara": "KU",
			"Kepulauan Riau": "KR",
			"Lampung": "LA",
			"Maluku": "MA",
			"Maluku Utara": "MU",
			"North Sumatra": "SU",
			"Nusa Tenggara Barat": "NB",
			"Nusa Tenggara Timur": "NT",
			"Papua": "PA",
			"Papua Barat": "PB",
			"Riau": "RI",
			"South Sumatra": "SS",
			"Sulawesi Barat": "SR",
			"Sulawesi Selatan": "SN",
			"Sulawesi Tengah": "ST",
			"Sulawesi Tenggara": "SG",
			"Sulawesi Utara": "SA",
			"West Sumatra": "SB",
			"Yogyakarta": "YO"
		},
		"province_alternate_names": {
			"Aceh": null,
			"Bali": null,
			"Bangka Belitung": null,
			"Banten": null,
			"Bengkulu": null,
			"Gorontalo": null,
			"Jakarta": null,
			"Jambi": null,
			"Jawa Barat": null,
			"Jawa Tengah": null,
			"Jawa Timur": null,
			"Kalimantan Barat": null,
			"Kalimantan Selatan": null,
			"Kalimantan Tengah": null,
			"Kalimantan Timur": null,
			"Kalimantan Utara": null,
			"Kepulauan Riau": null,
			"Lampung": null,
			"Maluku": null,
			"Maluku Utara": null,
			"North Sumatra": ["Sumatra Utara"],
			"Nusa Tenggara Barat": null,
			"Nusa Tenggara Timur": null,
			"Papua": null,
			"Papua Barat": null,
			"Riau": null,
			"South Sumatra": ["Sumatra Selatan"],
			"Sulawesi Barat": null,
			"Sulawesi Selatan": null,
			"Sulawesi Tengah": null,
			"Sulawesi Tenggara": null,
			"Sulawesi Utara": null,
			"West Sumatra": ["Sumatra Barat"],
			"Yogyakarta": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Iran, Islamic Republic Of": {
		"code": "IR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ir-680330c54ee3ba2f3528855ea02611ed16adcc63cf7f98cb5e8f2f10cb7a5743.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Iraq": {
		"code": "IQ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/iq-2fc377138af11be17c6f5e45da8dd971b237fab2bc7f273a01d5609796b66369.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Ireland": {
		"code": "IE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ie-8147f9c27f0e03a7873cd3183607439337bc9b49b8d2578c3819df5cd76bf02e.svg",
		"label": "County",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "County",
		"provinces": ["Carlow", "Cavan", "Clare", "Cork", "Donegal", "Dublin", "Galway", "Kerry", "Kildare", "Kilkenny", "Laois", "Leitrim", "Limerick", "Longford", "Louth", "Mayo", "Meath", "Monaghan", "Offaly", "Roscommon", "Sligo", "Tipperary", "Waterford", "Westmeath", "Wexford", "Wicklow"],
		"province_labels": {
			"Carlow": "Carlow",
			"Cavan": "Cavan",
			"Clare": "Clare",
			"Cork": "Cork",
			"Donegal": "Donegal",
			"Dublin": "Dublin",
			"Galway": "Galway",
			"Kerry": "Kerry",
			"Kildare": "Kildare",
			"Kilkenny": "Kilkenny",
			"Laois": "Laois",
			"Leitrim": "Leitrim",
			"Limerick": "Limerick",
			"Longford": "Longford",
			"Louth": "Louth",
			"Mayo": "Mayo",
			"Meath": "Meath",
			"Monaghan": "Monaghan",
			"Offaly": "Offaly",
			"Roscommon": "Roscommon",
			"Sligo": "Sligo",
			"Tipperary": "Tipperary",
			"Waterford": "Waterford",
			"Westmeath": "Westmeath",
			"Wexford": "Wexford",
			"Wicklow": "Wicklow"
		},
		"province_codes": {
			"Carlow": "CW",
			"Cavan": "CN",
			"Clare": "CE",
			"Cork": "CO",
			"Donegal": "DL",
			"Dublin": "D",
			"Galway": "G",
			"Kerry": "KY",
			"Kildare": "KE",
			"Kilkenny": "KK",
			"Laois": "LS",
			"Leitrim": "LM",
			"Limerick": "LK",
			"Longford": "LD",
			"Louth": "LH",
			"Mayo": "MO",
			"Meath": "MH",
			"Monaghan": "MN",
			"Offaly": "OY",
			"Roscommon": "RN",
			"Sligo": "SO",
			"Tipperary": "TA",
			"Waterford": "WD",
			"Westmeath": "WH",
			"Wexford": "WX",
			"Wicklow": "WW"
		},
		"province_alternate_names": {
			"Carlow": ["Ceatharlach", "Contae Cheatharlach", "County Carlow", "Co. Carlow"],
			"Cavan": ["An Cabhán", "An Cabhan", "Contae an Chabháin", "Contae an Chabhain", "County Cavan", "Co. Cavan"],
			"Clare": ["An Clár", "An Clar", "Contae an Chláir", "Contae an Chlair", "County Clare", "Co. Clare"],
			"Cork": ["Corcaigh", "Contae Chorcaí", "Contae Chorcai", "County Cork", "Co. Cork"],
			"Donegal": ["Dún na nGall", "Dun na nGall", "Contae Dhún na nGall", "Contae Dhun na nGall", "County Donegal", "Co. Donegal"],
			"Dublin": ["Baile Átha Cliath", "Baile Atha Cliath", "County Dublin", "Co. Dublin"],
			"Galway": ["Gaillimh", "Contae na Gaillimhe", "County Galway", "Co. Galway"],
			"Kerry": ["Ciarraí", "Ciarrai", "Contae Chiarraí", "Contae Chiarrai", "County Kerry", "Co. Kerry"],
			"Kildare": ["Cill Dara", "Contae Chill Dara", "County Kildare", "Co. Kildare"],
			"Kilkenny": ["Cill Chainnigh", "Contae Chill Chainnigh", "County Kilkenny", "Co. Kilkenny"],
			"Laois": ["Contae Laoise", "County Laois", "Co. Laois"],
			"Leitrim": ["Liatroim", "Contae Liatroma", "County Leitrim", "Co. Leitrim"],
			"Limerick": ["Luimneach", "Contae Luimnigh", "County Limerick", "Co. Limerick"],
			"Longford": ["An Longfort", "Contae an Longfoirt", "County Longford", "Co. Longford"],
			"Louth": ["Lú", "Lu", "Contae Lú", "Contae Lu", "County Louth", "Co. Louth"],
			"Mayo": ["Maigh Eo", "Contae Mhaigh Eo", "County Mayo", "Co. Mayo"],
			"Meath": ["An Mhí", "An Mhi", "Contae na Mí", "Contae na Mi", "County Meath", "Co. Meath"],
			"Monaghan": ["Muineachán", "Muineachan", "Contae Mhuineacháin", "Contae Mhuineachain", "County Monaghan", "Co. Monaghan"],
			"Offaly": ["Uíbh Fhailí", "Uibh Fhaili", "Contae Uíbh Fhailí", "Contae Uibh Fhaili", "County Offaly", "Co. Offaly"],
			"Roscommon": ["Ros Comáin", "Ros Comain", "Contae Ros Comáin", "Contae Ros Comain", "County Roscommon", "Co. Roscommon"],
			"Sligo": ["Sligeach", "Contae Shligigh", "County Sligo", "Co. Sligo"],
			"Tipperary": ["Tiobraid Árann", "Tiobraid Arann", "Contae Thiobraid Árann", "Contae Thiobraid Arann", "County Tipperary", "Co. Tipperary"],
			"Waterford": ["Port Láirge", "Port Lairge", "Contae Phort Láirge", "Contae Phort Lairge", "County Waterford", "Co. Waterford"],
			"Westmeath": ["An Iarmhí", "An Iarmhi", "Contae na hIarmhí", "Contae na hIarmhi", "County Westmeath", "Co. Westmeath"],
			"Wexford": ["Loch Garman", "Contae Loch Garman", "County Wexford", "Co. Wexford"],
			"Wicklow": ["Cill Mhantáin", "Cill Mhantain", "Contae Chill Mhantáin", "Contae Chill Mhantain", "County Wicklow", "Co. Wicklow"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "County",
		"checkout_zone_placeholder": "County"
	},
	"Isle Of Man": {
		"code": "IM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/im-eeb3c6dc669cddbb33432b2429d9c85242e77b353164a48a16466d05f935e0d2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Israel": {
		"code": "IL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/il-e2f8bc4dab5fcdf4901092f3e50d733859dbf9afc960b2ff159ef4042f58b39c.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Italy": {
		"code": "IT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/it-df6faa9601d03e30d30e9a0e630d0286bcdc4306a0570f217034077e7f5875f8.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Agrigento", "Alessandria", "Ancona", "Aosta", "Arezzo", "Ascoli Piceno", "Asti", "Avellino", "Bari", "Barletta-Andria-Trani", "Belluno", "Benevento", "Bergamo", "Biella", "Bologna", "Bolzano", "Brescia", "Brindisi", "Cagliari", "Caltanissetta", "Campobasso", "Carbonia-Iglesias", "Caserta", "Catania", "Catanzaro", "Chieti", "Como", "Cosenza", "Cremona", "Crotone", "Cuneo", "Enna", "Fermo", "Ferrara", "Firenze", "Foggia", "Forlì-Cesena", "Frosinone", "Genova", "Gorizia", "Grosseto", "Imperia", "Isernia", "L'Aquila", "La Spezia", "Latina", "Lecce", "Lecco", "Livorno", "Lodi", "Lucca", "Macerata", "Mantova", "Massa-Carrara", "Matera", "Medio Campidano", "Messina", "Milano", "Modena", "Monza e Brianza", "Napoli", "Novara", "Nuoro", "Ogliastra", "Olbia-Tempio", "Oristano", "Padova", "Palermo", "Parma", "Pavia", "Perugia", "Pesaro e Urbino", "Pescara", "Piacenza", "Pisa", "Pistoia", "Pordenone", "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Calabria", "Reggio Emilia", "Rieti", "Rimini", "Roma", "Rovigo", "Salerno", "Sassari", "Savona", "Siena", "Siracusa", "Sondrio", "Taranto", "Teramo", "Terni", "Torino", "Trapani", "Trento", "Treviso", "Trieste", "Udine", "Varese", "Venezia", "Verbano-Cusio-Ossola", "Vercelli", "Verona", "Vibo Valentia", "Vicenza", "Viterbo"],
		"province_labels": {
			"Agrigento": "Agrigento",
			"Alessandria": "Alessandria",
			"Ancona": "Ancona",
			"Aosta": "Aosta",
			"Arezzo": "Arezzo",
			"Ascoli Piceno": "Ascoli Piceno",
			"Asti": "Asti",
			"Avellino": "Avellino",
			"Bari": "Bari",
			"Barletta-Andria-Trani": "Barletta-Andria-Trani",
			"Belluno": "Belluno",
			"Benevento": "Benevento",
			"Bergamo": "Bergamo",
			"Biella": "Biella",
			"Bologna": "Bologna",
			"Brescia": "Brescia",
			"Brindisi": "Brindisi",
			"Cagliari": "Cagliari",
			"Caltanissetta": "Caltanissetta",
			"Campobasso": "Campobasso",
			"Carbonia-Iglesias": "Carbonia-Iglesias",
			"Caserta": "Caserta",
			"Catania": "Catania",
			"Catanzaro": "Catanzaro",
			"Chieti": "Chieti",
			"Como": "Como",
			"Cosenza": "Cosenza",
			"Cremona": "Cremona",
			"Crotone": "Crotone",
			"Cuneo": "Cuneo",
			"Enna": "Enna",
			"Fermo": "Fermo",
			"Ferrara": "Ferrara",
			"Firenze": "Florence",
			"Foggia": "Foggia",
			"Forlì-Cesena": "Forlì-Cesena",
			"Frosinone": "Frosinone",
			"Genova": "Genoa",
			"Gorizia": "Gorizia",
			"Grosseto": "Grosseto",
			"Imperia": "Imperia",
			"Isernia": "Isernia",
			"La Spezia": "La Spezia",
			"Latina": "Latina",
			"Lecce": "Lecce",
			"Lecco": "Lecco",
			"Livorno": "Livorno",
			"Lodi": "Lodi",
			"Lucca": "Lucca",
			"L'Aquila": "L’Aquila",
			"Macerata": "Macerata",
			"Mantova": "Mantua",
			"Massa-Carrara": "Massa and Carrara",
			"Matera": "Matera",
			"Medio Campidano": "Medio Campidano",
			"Messina": "Messina",
			"Milano": "Milan",
			"Modena": "Modena",
			"Monza e Brianza": "Monza and Brianza",
			"Napoli": "Naples",
			"Novara": "Novara",
			"Nuoro": "Nuoro",
			"Ogliastra": "Ogliastra",
			"Olbia-Tempio": "Olbia-Tempio",
			"Oristano": "Oristano",
			"Padova": "Padua",
			"Palermo": "Palermo",
			"Parma": "Parma",
			"Pavia": "Pavia",
			"Perugia": "Perugia",
			"Pesaro e Urbino": "Pesaro and Urbino",
			"Pescara": "Pescara",
			"Piacenza": "Piacenza",
			"Pisa": "Pisa",
			"Pistoia": "Pistoia",
			"Pordenone": "Pordenone",
			"Potenza": "Potenza",
			"Prato": "Prato",
			"Ragusa": "Ragusa",
			"Ravenna": "Ravenna",
			"Reggio Calabria": "Reggio Calabria",
			"Reggio Emilia": "Reggio Emilia",
			"Rieti": "Rieti",
			"Rimini": "Rimini",
			"Roma": "Rome",
			"Rovigo": "Rovigo",
			"Salerno": "Salerno",
			"Sassari": "Sassari",
			"Savona": "Savona",
			"Siena": "Siena",
			"Sondrio": "Sondrio",
			"Bolzano": "South Tyrol",
			"Siracusa": "Syracuse",
			"Taranto": "Taranto",
			"Teramo": "Teramo",
			"Terni": "Terni",
			"Trapani": "Trapani",
			"Trento": "Trentino",
			"Treviso": "Treviso",
			"Trieste": "Trieste",
			"Torino": "Turin",
			"Udine": "Udine",
			"Varese": "Varese",
			"Venezia": "Venice",
			"Verbano-Cusio-Ossola": "Verbano-Cusio-Ossola",
			"Vercelli": "Vercelli",
			"Verona": "Verona",
			"Vibo Valentia": "Vibo Valentia",
			"Vicenza": "Vicenza",
			"Viterbo": "Viterbo"
		},
		"province_codes": {
			"Agrigento": "AG",
			"Alessandria": "AL",
			"Ancona": "AN",
			"Aosta": "AO",
			"Arezzo": "AR",
			"Ascoli Piceno": "AP",
			"Asti": "AT",
			"Avellino": "AV",
			"Bari": "BA",
			"Barletta-Andria-Trani": "BT",
			"Belluno": "BL",
			"Benevento": "BN",
			"Bergamo": "BG",
			"Biella": "BI",
			"Bologna": "BO",
			"Bolzano": "BZ",
			"Brescia": "BS",
			"Brindisi": "BR",
			"Cagliari": "CA",
			"Caltanissetta": "CL",
			"Campobasso": "CB",
			"Carbonia-Iglesias": "CI",
			"Caserta": "CE",
			"Catania": "CT",
			"Catanzaro": "CZ",
			"Chieti": "CH",
			"Como": "CO",
			"Cosenza": "CS",
			"Cremona": "CR",
			"Crotone": "KR",
			"Cuneo": "CN",
			"Enna": "EN",
			"Fermo": "FM",
			"Ferrara": "FE",
			"Firenze": "FI",
			"Foggia": "FG",
			"Forlì-Cesena": "FC",
			"Frosinone": "FR",
			"Genova": "GE",
			"Gorizia": "GO",
			"Grosseto": "GR",
			"Imperia": "IM",
			"Isernia": "IS",
			"L'Aquila": "AQ",
			"La Spezia": "SP",
			"Latina": "LT",
			"Lecce": "LE",
			"Lecco": "LC",
			"Livorno": "LI",
			"Lodi": "LO",
			"Lucca": "LU",
			"Macerata": "MC",
			"Mantova": "MN",
			"Massa-Carrara": "MS",
			"Matera": "MT",
			"Medio Campidano": "VS",
			"Messina": "ME",
			"Milano": "MI",
			"Modena": "MO",
			"Monza e Brianza": "MB",
			"Napoli": "NA",
			"Novara": "NO",
			"Nuoro": "NU",
			"Ogliastra": "OG",
			"Olbia-Tempio": "OT",
			"Oristano": "OR",
			"Padova": "PD",
			"Palermo": "PA",
			"Parma": "PR",
			"Pavia": "PV",
			"Perugia": "PG",
			"Pesaro e Urbino": "PU",
			"Pescara": "PE",
			"Piacenza": "PC",
			"Pisa": "PI",
			"Pistoia": "PT",
			"Pordenone": "PN",
			"Potenza": "PZ",
			"Prato": "PO",
			"Ragusa": "RG",
			"Ravenna": "RA",
			"Reggio Calabria": "RC",
			"Reggio Emilia": "RE",
			"Rieti": "RI",
			"Rimini": "RN",
			"Roma": "RM",
			"Rovigo": "RO",
			"Salerno": "SA",
			"Sassari": "SS",
			"Savona": "SV",
			"Siena": "SI",
			"Siracusa": "SR",
			"Sondrio": "SO",
			"Taranto": "TA",
			"Teramo": "TE",
			"Terni": "TR",
			"Torino": "TO",
			"Trapani": "TP",
			"Trento": "TN",
			"Treviso": "TV",
			"Trieste": "TS",
			"Udine": "UD",
			"Varese": "VA",
			"Venezia": "VE",
			"Verbano-Cusio-Ossola": "VB",
			"Vercelli": "VC",
			"Verona": "VR",
			"Vibo Valentia": "VV",
			"Vicenza": "VI",
			"Viterbo": "VT"
		},
		"province_alternate_names": {
			"Agrigento": null,
			"Alessandria": null,
			"Ancona": null,
			"Aosta": null,
			"Arezzo": null,
			"Ascoli Piceno": null,
			"Asti": null,
			"Avellino": null,
			"Bari": null,
			"Barletta-Andria-Trani": null,
			"Belluno": null,
			"Benevento": null,
			"Bergamo": null,
			"Biella": null,
			"Bologna": null,
			"Bolzano": null,
			"Brescia": null,
			"Brindisi": null,
			"Cagliari": null,
			"Caltanissetta": null,
			"Campobasso": null,
			"Carbonia-Iglesias": null,
			"Caserta": null,
			"Catania": null,
			"Catanzaro": null,
			"Chieti": null,
			"Como": null,
			"Cosenza": null,
			"Cremona": null,
			"Crotone": null,
			"Cuneo": null,
			"Enna": null,
			"Fermo": null,
			"Ferrara": null,
			"Firenze": null,
			"Foggia": null,
			"Forlì-Cesena": ["Forli-Cesena"],
			"Frosinone": null,
			"Genova": null,
			"Gorizia": null,
			"Grosseto": null,
			"Imperia": null,
			"Isernia": null,
			"L'Aquila": null,
			"La Spezia": null,
			"Latina": null,
			"Lecce": null,
			"Lecco": null,
			"Livorno": null,
			"Lodi": null,
			"Lucca": null,
			"Macerata": null,
			"Mantova": null,
			"Massa-Carrara": null,
			"Matera": null,
			"Medio Campidano": null,
			"Messina": null,
			"Milano": null,
			"Modena": null,
			"Monza e Brianza": null,
			"Napoli": null,
			"Novara": null,
			"Nuoro": null,
			"Ogliastra": null,
			"Olbia-Tempio": null,
			"Oristano": null,
			"Padova": null,
			"Palermo": null,
			"Parma": null,
			"Pavia": null,
			"Perugia": null,
			"Pesaro e Urbino": null,
			"Pescara": null,
			"Piacenza": null,
			"Pisa": null,
			"Pistoia": null,
			"Pordenone": null,
			"Potenza": null,
			"Prato": null,
			"Ragusa": null,
			"Ravenna": null,
			"Reggio Calabria": ["Calabria"],
			"Reggio Emilia": null,
			"Rieti": null,
			"Rimini": null,
			"Roma": null,
			"Rovigo": null,
			"Salerno": null,
			"Sassari": null,
			"Savona": null,
			"Siena": null,
			"Siracusa": null,
			"Sondrio": null,
			"Taranto": null,
			"Teramo": null,
			"Terni": null,
			"Torino": null,
			"Trapani": null,
			"Trento": null,
			"Treviso": null,
			"Trieste": null,
			"Udine": null,
			"Varese": null,
			"Venezia": null,
			"Verbano-Cusio-Ossola": null,
			"Vercelli": null,
			"Verona": null,
			"Vibo Valentia": null,
			"Vicenza": null,
			"Viterbo": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Jamaica": {
		"code": "JM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/jm-0e3edd42bd4bf86be415d5dc3689bdcb816b00eab77d0b56552091b85e775114.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Japan": {
		"code": "JP",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/jp-51834ceb282af719ada5d7477c503a77711d1e57d0b0a5665d78497e6c9521c8.svg",
		"label": "Prefecture",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "N_p_c_sc_a_a",
		"provinces_beta": null,
		"province_label": "Prefecture",
		"provinces": ["Hokkaidō", "Aomori", "Iwate", "Miyagi", "Akita", "Yamagata", "Fukushima", "Ibaraki", "Tochigi", "Gunma", "Saitama", "Chiba", "Tōkyō", "Kanagawa", "Niigata", "Toyama", "Ishikawa", "Fukui", "Yamanashi", "Nagano", "Gifu", "Shizuoka", "Aichi", "Mie", "Shiga", "Kyōto", "Ōsaka", "Hyōgo", "Nara", "Wakayama", "Tottori", "Shimane", "Okayama", "Hiroshima", "Yamaguchi", "Tokushima", "Kagawa", "Ehime", "Kōchi", "Fukuoka", "Saga", "Nagasaki", "Kumamoto", "Ōita", "Miyazaki", "Kagoshima", "Okinawa"],
		"province_labels": {
			"Hokkaidō": "Hokkaido",
			"Aomori": "Aomori",
			"Iwate": "Iwate",
			"Miyagi": "Miyagi",
			"Akita": "Akita",
			"Yamagata": "Yamagata",
			"Fukushima": "Fukushima",
			"Ibaraki": "Ibaraki",
			"Tochigi": "Tochigi",
			"Gunma": "Gunma",
			"Saitama": "Saitama",
			"Chiba": "Chiba",
			"Tōkyō": "Tokyo",
			"Kanagawa": "Kanagawa",
			"Niigata": "Niigata",
			"Toyama": "Toyama",
			"Ishikawa": "Ishikawa",
			"Fukui": "Fukui",
			"Yamanashi": "Yamanashi",
			"Nagano": "Nagano",
			"Gifu": "Gifu",
			"Shizuoka": "Shizuoka",
			"Aichi": "Aichi",
			"Mie": "Mie",
			"Shiga": "Shiga",
			"Kyōto": "Kyoto",
			"Ōsaka": "Osaka",
			"Hyōgo": "Hyogo",
			"Nara": "Nara",
			"Wakayama": "Wakayama",
			"Tottori": "Tottori",
			"Shimane": "Shimane",
			"Okayama": "Okayama",
			"Hiroshima": "Hiroshima",
			"Yamaguchi": "Yamaguchi",
			"Tokushima": "Tokushima",
			"Kagawa": "Kagawa",
			"Ehime": "Ehime",
			"Kōchi": "Kochi",
			"Fukuoka": "Fukuoka",
			"Saga": "Saga",
			"Nagasaki": "Nagasaki",
			"Kumamoto": "Kumamoto",
			"Ōita": "Oita",
			"Miyazaki": "Miyazaki",
			"Kagoshima": "Kagoshima",
			"Okinawa": "Okinawa"
		},
		"province_codes": {
			"Hokkaidō": "JP-01",
			"Aomori": "JP-02",
			"Iwate": "JP-03",
			"Miyagi": "JP-04",
			"Akita": "JP-05",
			"Yamagata": "JP-06",
			"Fukushima": "JP-07",
			"Ibaraki": "JP-08",
			"Tochigi": "JP-09",
			"Gunma": "JP-10",
			"Saitama": "JP-11",
			"Chiba": "JP-12",
			"Tōkyō": "JP-13",
			"Kanagawa": "JP-14",
			"Niigata": "JP-15",
			"Toyama": "JP-16",
			"Ishikawa": "JP-17",
			"Fukui": "JP-18",
			"Yamanashi": "JP-19",
			"Nagano": "JP-20",
			"Gifu": "JP-21",
			"Shizuoka": "JP-22",
			"Aichi": "JP-23",
			"Mie": "JP-24",
			"Shiga": "JP-25",
			"Kyōto": "JP-26",
			"Ōsaka": "JP-27",
			"Hyōgo": "JP-28",
			"Nara": "JP-29",
			"Wakayama": "JP-30",
			"Tottori": "JP-31",
			"Shimane": "JP-32",
			"Okayama": "JP-33",
			"Hiroshima": "JP-34",
			"Yamaguchi": "JP-35",
			"Tokushima": "JP-36",
			"Kagawa": "JP-37",
			"Ehime": "JP-38",
			"Kōchi": "JP-39",
			"Fukuoka": "JP-40",
			"Saga": "JP-41",
			"Nagasaki": "JP-42",
			"Kumamoto": "JP-43",
			"Ōita": "JP-44",
			"Miyazaki": "JP-45",
			"Kagoshima": "JP-46",
			"Okinawa": "JP-47"
		},
		"province_alternate_names": {
			"Hokkaidō": ["Hokkaido", "Hokkaido Prefecture", "北海道"],
			"Aomori": ["Aomori Prefecture", "Aomori-ken", "青森県", "青森"],
			"Iwate": ["Iwate Prefecture", "Iwate-ken", "岩手県", "岩手"],
			"Miyagi": ["Miyagi Prefecture", "Miyagi-ken", "宮城県", "宮城"],
			"Akita": ["Akita Prefecture", "Akita-ken", "秋田県", "秋田"],
			"Yamagata": ["Yamagata Prefecture", "Yamagata-ken", "山形県", "山形"],
			"Fukushima": ["Fukushima Prefecture", "Fukushima-ken", "福島県", "福島"],
			"Ibaraki": ["Ibaraki Prefecture", "Ibaraki-ken", "茨城県", "茨城"],
			"Tochigi": ["Tochigi Prefecture", "Tochigi-ken", "栃木県", "栃木"],
			"Gunma": ["Gunma Prefecture", "Gunma-ken", "群馬県", "群馬"],
			"Saitama": ["Saitama Prefecture", "Saitama-ken", "埼玉県", "埼玉"],
			"Chiba": ["Chiba Prefecture", "Chiba-ken", "千葉県", "千葉"],
			"Tōkyō": ["Tokyo", "Tokyo Prefecture", "Tōkyō-to", "Tokyo-to", "東京都", "東京"],
			"Kanagawa": ["Kanagawa Prefecture", "Kanagawa-ken", "神奈川県", "神奈川"],
			"Niigata": ["Niigata Prefecture", "Niigata-ken", "新潟県", "新潟"],
			"Toyama": ["Toyama Prefecture", "Toyama-ken", "富山県", "富山"],
			"Ishikawa": ["Ishikawa Prefecture", "Ishikawa-ken", "石川県", "石川"],
			"Fukui": ["Fukui Prefecture", "Fukui-ken", "福井県", "福井"],
			"Yamanashi": ["Yamanashi Prefecture", "Yamanashi-ken", "山梨県", "山梨"],
			"Nagano": ["Nagano Prefecture", "Nagano-ken", "長野県", "長野"],
			"Gifu": ["Gifu Prefecture", "Gifu-ken", "岐阜県", "岐阜"],
			"Shizuoka": ["Shizuoka Prefecture", "Shizuoka-ken", "静岡県", "静岡"],
			"Aichi": ["Aichi Prefecture", "Aichi-ken", "愛知県", "愛知"],
			"Mie": ["Mie Prefecture", "Mie-ken", "三重県", "三重"],
			"Shiga": ["Shiga Prefecture", "Shiga-ken", "滋賀県", "滋賀"],
			"Kyōto": ["Kyoto", "Kyoto Prefecture", "Kyōto-fu", "Kyoto-fu", "京都府", "京都"],
			"Ōsaka": ["Osaka", "Osaka Prefecture", "Ōsaka-fu", "Osaka-fu", "大阪府", "大阪"],
			"Hyōgo": ["Hyogo", "Hyogo Prefecture", "Hyōgo-ken", "Hyogo-ken", "兵庫県", "兵庫"],
			"Nara": ["Nara Prefecture", "Nara-ken", "奈良県", "奈良"],
			"Wakayama": ["Wakayama Prefecture", "Wakayama-ken", "和歌山県", "和歌山"],
			"Tottori": ["Tottori Prefecture", "Tottori-ken", "鳥取県", "鳥取"],
			"Shimane": ["Shimane Prefecture", "Shimane-ken", "島根県", "島根"],
			"Okayama": ["Okayama Prefecture", "Okayama-ken", "岡山県", "岡山"],
			"Hiroshima": ["Hiroshima Prefecture", "Hiroshima-ken", "広島県", "広島"],
			"Yamaguchi": ["Yamaguchi Prefecture", "Yamaguchi-ken", "山口県", "山口"],
			"Tokushima": ["Tokushima Prefecture", "Tokushima-ken", "徳島県", "徳島"],
			"Kagawa": ["Kagawa Prefecture", "Kagawa-ken", "香川県", "香川"],
			"Ehime": ["Ehime Prefecture", "Ehime-ken", "愛媛県", "愛媛"],
			"Kōchi": ["Kochi", "Kochi Prefecture", "Kōchi-ken", "Kochi-ken", "高知県", "高知"],
			"Fukuoka": ["Fukuoka Prefecture", "Fukuoka-ken", "福岡県", "福岡"],
			"Saga": ["Saga Prefecture", "Saga-ken", "佐賀県", "佐賀"],
			"Nagasaki": ["Nagasaki Prefecture", "Nagasaki-ken", "長崎県", "長崎"],
			"Kumamoto": ["Kumamoto Prefecture", "Kumamoto-ken", "熊本県", "熊本"],
			"Ōita": ["Oita", "Oita Prefecture", "Ōita-ken", "Oita-ken", "大分県", "大分"],
			"Miyazaki": ["Miyazaki Prefecture", "Miyazaki-ken", "宮崎県", "宮崎"],
			"Kagoshima": ["Kagoshima Prefecture", "Kagoshima-ken", "鹿児島県", "鹿児島"],
			"Okinawa": ["Okinawa Prefecture", "Okinawa-ken", "沖縄県", "沖縄"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Prefecture",
		"checkout_zone_placeholder": "Prefecture"
	},
	"Jersey": {
		"code": "JE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/je-ed7839ff4b12fae6c676427feb0a2ca599a9f66bd97f887a5ab84443af5a38b9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Jordan": {
		"code": "JO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/jo-dff53aefd172f5a6d6e325609fdb4a07d83e0debd66e5c38352f49ad1bd8160c.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Kazakhstan": {
		"code": "KZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/kz-b5f40935a6b8bd057a0ede54b93916f4707a5c90ffe0199397bb4f5664a35876.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Kenya": {
		"code": "KE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ke-edc7377bd7abe9e998476174f05dd510af1eadd5f4d010ebac91df6686b2762e.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Kiribati": {
		"code": "KI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ki-27438e76ea03d1a7ef2d083b8f15de1c7459db5089d28812bacd8ac627028d94.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Korea, Democratic People's Republic Of": {
		"code": "KP",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/kp-b28bc1d8a19853619340a9d9cb7031b444b370331b5844c4c43d2960426e9e9c.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Kosovo": {
		"code": "XK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/xk-25d720dd9c8d9a9cb2f9904824d183054d4e01a8d7c06c2bf2412ea341e26e85.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Kuwait": {
		"code": "KW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/kw-12b68de9c29ff5e79c9e92c8a31f21de9654122dff304fe90c07c797f994dcd8.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Kyrgyzstan": {
		"code": "KG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/kg-9eec999003db08c23990f0a7f5f7f3cff5cd24161a70fbaff7679b784add8da0.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Lao People's Democratic Republic": {
		"code": "LA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/la-144b105e19bcb19e4420dc87b12b9d39e03f80d3cf1224061f283d626433c892.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Province"
	},
	"Latvia": {
		"code": "LV",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/lv-b4dedfbd55b8f448602419e83c40ed6e3ac1cc9752c62b7905ac9800cee715af.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Lebanon": {
		"code": "LB",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/lb-c63097230534fca80f65af98f1465625baf6b4f05a977d19d8833f89bad4557d.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Lesotho": {
		"code": "LS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ls-69b000e98f9ddb08fc8e38d1b2d5217f122265d4cc544930a63b489f4c411a44.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Liberia": {
		"code": "LR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/lr-d0286d2e904808cc882b263cf582c3e6f390582fd9ac8aa450b2e69ebd9bc84d.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Libyan Arab Jamahiriya": {
		"code": "LY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ly-3de463fa8f7de627b85cba38c090a0e69d1ae88fcb62b78e162842d84ac4c273.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Liechtenstein": {
		"code": "LI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/li-bd0573b7eee6b796f5e1ce27eeebd8176fe19c7e64dfca90071179e8428ebec5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Lithuania": {
		"code": "LT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/lt-7e19f8f51065107f5f9cb2b71e74617a4b158ed990f22a5b66bd1c663454c9f8.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Luxembourg": {
		"code": "LU",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/lu-a71df8b19ddbb2961172c98762fd06c1046b3cad36b63dd45436a2896b0067cf.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Macao": {
		"code": "MO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mo-9f244f9cd5f2279bc8ac1f4e5d01f7c0afaff6b64e566346740a102340cc0f35.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Madagascar": {
		"code": "MG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mg-2b91613e51c09ec0dcd2fa8d3d53cd4140eb1a204676c00cdd5fda1a762363a6.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Malawi": {
		"code": "MW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mw-e9c9476184afa84a0bde62516e0078ff0594b516cd838119ca7a93d273db81ee.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Malaysia": {
		"code": "MY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/my-62b6693d248cda235b57a98a890d31675b9f374ae77d1c6432a80509d9708d5e.svg",
		"label": "State\/territory",
		"zip_label": "Postcode",
		"zip_placeholder": "Postcode",
		"zip_required": true,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "State\/territory",
		"provinces": ["Johor", "Kedah", "Kelantan", "Kuala Lumpur", "Labuan", "Melaka", "Negeri Sembilan", "Pahang", "Penang", "Perak", "Perlis", "Putrajaya", "Sabah", "Sarawak", "Selangor", "Terengganu"],
		"province_labels": {
			"Johor": "Johor",
			"Kedah": "Kedah",
			"Kelantan": "Kelantan",
			"Kuala Lumpur": "Kuala Lumpur",
			"Labuan": "Labuan",
			"Melaka": "Malacca",
			"Negeri Sembilan": "Negeri Sembilan",
			"Pahang": "Pahang",
			"Penang": "Penang",
			"Perak": "Perak",
			"Perlis": "Perlis",
			"Putrajaya": "Putrajaya",
			"Sabah": "Sabah",
			"Sarawak": "Sarawak",
			"Selangor": "Selangor",
			"Terengganu": "Terengganu"
		},
		"province_codes": {
			"Johor": "JHR",
			"Kedah": "KDH",
			"Kelantan": "KTN",
			"Kuala Lumpur": "KUL",
			"Labuan": "LBN",
			"Melaka": "MLK",
			"Negeri Sembilan": "NSN",
			"Pahang": "PHG",
			"Penang": "PNG",
			"Perak": "PRK",
			"Perlis": "PLS",
			"Putrajaya": "PJY",
			"Sabah": "SBH",
			"Sarawak": "SWK",
			"Selangor": "SGR",
			"Terengganu": "TRG"
		},
		"province_alternate_names": {
			"Johor": null,
			"Kedah": null,
			"Kelantan": null,
			"Kuala Lumpur": null,
			"Labuan": null,
			"Melaka": null,
			"Negeri Sembilan": null,
			"Pahang": null,
			"Penang": ["Pulau Pinang"],
			"Perak": null,
			"Perlis": null,
			"Putrajaya": null,
			"Sabah": null,
			"Sarawak": null,
			"Selangor": null,
			"Terengganu": null
		},
		"checkout_zip_label": "Postcode",
		"checkout_zip_placeholder": "Postcode",
		"checkout_zone_label": "State\/territory",
		"checkout_zone_placeholder": "State\/territory"
	},
	"Maldives": {
		"code": "MV",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mv-c2eb047ffa827867bd29048b939c3f81a94aad885f738b00504624a254161dd4.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Mali": {
		"code": "ML",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ml-ceed9317fbbb708971d76b1f0f5979130ce44f7c99b829dd226c777094c135e5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Malta": {
		"code": "MT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mt-a5effdb9c54a7168fced0465607d245ab70ba7d19cc72bb47c847178750eead9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Martinique": {
		"code": "MQ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mq-29cf42ac8ce58f180821b06aba8015ecd77bcd8a84d7e6f5c4cba71410662ecb.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Mauritania": {
		"code": "MR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mr-7394cb78de686b7b2b308c26afaeeec859ca44135429edaf704aaa4c0f25fad8.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Mauritius": {
		"code": "MU",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mu-7554fbc2982cdb1b6537c8e8d87758cb3efa5dfc83c5f7a37e4333e97868cdb6.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Mayotte": {
		"code": "YT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/yt-53a8a7d8c53d71036c24aebb45e0192f98cad78b4ea3cfdeb695bd2f9bf2b7f5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Mexico": {
		"code": "MX",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mx-7c49b8206aa19f98841540b81f52c02bc28e0058528a8c0b2af4b6178de83f10.svg",
		"label": "State",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "State",
		"provinces": ["Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "Ciudad de México", "Coahuila", "Colima", "Durango", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "México", "Michoacán", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas"],
		"province_labels": {
			"Aguascalientes": "Aguascalientes",
			"Baja California": "Baja California",
			"Baja California Sur": "Baja California Sur",
			"Campeche": "Campeche",
			"Chiapas": "Chiapas",
			"Chihuahua": "Chihuahua",
			"Ciudad de México": "Ciudad de Mexico",
			"Coahuila": "Coahuila",
			"Colima": "Colima",
			"Durango": "Durango",
			"Guanajuato": "Guanajuato",
			"Guerrero": "Guerrero",
			"Hidalgo": "Hidalgo",
			"Jalisco": "Jalisco",
			"México": "Mexico State",
			"Michoacán": "Michoacán",
			"Morelos": "Morelos",
			"Nayarit": "Nayarit",
			"Nuevo León": "Nuevo León",
			"Oaxaca": "Oaxaca",
			"Puebla": "Puebla",
			"Querétaro": "Querétaro",
			"Quintana Roo": "Quintana Roo",
			"San Luis Potosí": "San Luis Potosí",
			"Sinaloa": "Sinaloa",
			"Sonora": "Sonora",
			"Tabasco": "Tabasco",
			"Tamaulipas": "Tamaulipas",
			"Tlaxcala": "Tlaxcala",
			"Veracruz": "Veracruz",
			"Yucatán": "Yucatán",
			"Zacatecas": "Zacatecas"
		},
		"province_codes": {
			"Aguascalientes": "AGS",
			"Baja California": "BC",
			"Baja California Sur": "BCS",
			"Campeche": "CAMP",
			"Chiapas": "CHIS",
			"Chihuahua": "CHIH",
			"Ciudad de México": "DF",
			"Coahuila": "COAH",
			"Colima": "COL",
			"Durango": "DGO",
			"Guanajuato": "GTO",
			"Guerrero": "GRO",
			"Hidalgo": "HGO",
			"Jalisco": "JAL",
			"México": "MEX",
			"Michoacán": "MICH",
			"Morelos": "MOR",
			"Nayarit": "NAY",
			"Nuevo León": "NL",
			"Oaxaca": "OAX",
			"Puebla": "PUE",
			"Querétaro": "QRO",
			"Quintana Roo": "Q ROO",
			"San Luis Potosí": "SLP",
			"Sinaloa": "SIN",
			"Sonora": "SON",
			"Tabasco": "TAB",
			"Tamaulipas": "TAMPS",
			"Tlaxcala": "TLAX",
			"Veracruz": "VER",
			"Yucatán": "YUC",
			"Zacatecas": "ZAC"
		},
		"province_alternate_names": {
			"Aguascalientes": null,
			"Baja California": null,
			"Baja California Sur": null,
			"Campeche": null,
			"Chiapas": null,
			"Chihuahua": null,
			"Ciudad de México": ["Ciudad de Mexico", "CDMX"],
			"Coahuila": null,
			"Colima": null,
			"Durango": null,
			"Guanajuato": null,
			"Guerrero": null,
			"Hidalgo": null,
			"Jalisco": ["Jal."],
			"México": ["Mexico"],
			"Michoacán": ["Michoacan"],
			"Morelos": null,
			"Nayarit": null,
			"Nuevo León": ["Nuevo Leon"],
			"Oaxaca": null,
			"Puebla": null,
			"Querétaro": ["Queretaro"],
			"Quintana Roo": null,
			"San Luis Potosí": ["San Luis Potosi"],
			"Sinaloa": null,
			"Sonora": null,
			"Tabasco": null,
			"Tamaulipas": null,
			"Tlaxcala": null,
			"Veracruz": null,
			"Yucatán": ["Yucatan"],
			"Zacatecas": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "State",
		"checkout_zone_placeholder": "State"
	},
	"Moldova, Republic of": {
		"code": "MD",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/md-e35529c79c00076bd2150fd41f4b1cba0e999f82d5c43ae955cc578a361faa16.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Monaco": {
		"code": "MC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mc-c11b3585a056936dd491686fd8d89e6b07488a803348fc5875d64d2a89b8ff05.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Mongolia": {
		"code": "MN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mn-88753edc378f38487765464cff5fc819e36a65effb6dd1424d45ece6a1647e1d.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Montenegro": {
		"code": "ME",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/me-6e3e694cab938cc673f3380a3e2b5baafe2c795cd73c9a5c3708e054b6778b13.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Montserrat": {
		"code": "MS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ms-e4bf8dedd7c10ae7ceff1bac1af7c79ad9e86a2dad24407f8e913ee35585f4d8.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Morocco": {
		"code": "MA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ma-35e1c070d6c6783bf105a3ad485320813e8d45651636d2a83f6fa0f363877abc.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Mozambique": {
		"code": "MZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mz-1c38e23f096018a517296eeb728ce615b81fd4609f54d21a5d78a8e047788dd3.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Myanmar": {
		"code": "MM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mm-e02730c89f8713dca8a8f14101887d6188415613803ab3bb29c8514590909985.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Namibia": {
		"code": "NA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/na-3cc917f4965db4ec44f11752ccedd8e1b7d5ba4a3a4b9d3aa57c77fbfa09b674.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Nauru": {
		"code": "NR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/nr-e508ea0235490f99c9324cc8fd18d4d6880b4eb7c31dfda6bd355f6589e4045b.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Netherlands": {
		"code": "NL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/nl-1e00d26bd585c1484559fa8676f9b81bce9578ae149b454921f60392a106a328.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Netherlands Antilles": {
		"code": "AN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/an-674c77b804f2adf1488993b5a8cbbb0501da5fcc8a8b88a3835f3338a1865ecc.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"New Caledonia": {
		"code": "NC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/nc-53a8a7d8c53d71036c24aebb45e0192f98cad78b4ea3cfdeb695bd2f9bf2b7f5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"New Zealand": {
		"code": "NZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/nz-067fcad818cb43f94a1b4912fc8aabba2ebf649c0012a155227b7b9d7bff5e2a.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Auckland", "Bay of Plenty", "Canterbury", "Chatham Islands", "Gisborne", "Hawke's Bay", "Manawatu-Wanganui", "Marlborough", "Nelson", "Northland", "Otago", "Southland", "Taranaki", "Tasman", "Waikato", "Wellington", "West Coast"],
		"province_labels": {
			"Auckland": "Auckland",
			"Bay of Plenty": "Bay of Plenty",
			"Canterbury": "Canterbury",
			"Chatham Islands": "Chatham Islands",
			"Gisborne": "Gisborne",
			"Hawke's Bay": "Hawke’s Bay",
			"Manawatu-Wanganui": "Manawatu-Wanganui",
			"Marlborough": "Marlborough",
			"Nelson": "Nelson",
			"Northland": "Northland",
			"Otago": "Otago",
			"Southland": "Southland",
			"Taranaki": "Taranaki",
			"Tasman": "Tasman",
			"Waikato": "Waikato",
			"Wellington": "Wellington",
			"West Coast": "West Coast"
		},
		"province_codes": {
			"Auckland": "AUK",
			"Bay of Plenty": "BOP",
			"Canterbury": "CAN",
			"Chatham Islands": "CIT",
			"Gisborne": "GIS",
			"Hawke's Bay": "HKB",
			"Manawatu-Wanganui": "MWT",
			"Marlborough": "MBH",
			"Nelson": "NSN",
			"Northland": "NTL",
			"Otago": "OTA",
			"Southland": "STL",
			"Taranaki": "TKI",
			"Tasman": "TAS",
			"Waikato": "WKO",
			"Wellington": "WGN",
			"West Coast": "WTC"
		},
		"province_alternate_names": {
			"Auckland": null,
			"Bay of Plenty": null,
			"Canterbury": null,
			"Chatham Islands": null,
			"Gisborne": null,
			"Hawke's Bay": null,
			"Manawatu-Wanganui": null,
			"Marlborough": null,
			"Nelson": null,
			"Northland": null,
			"Otago": null,
			"Southland": null,
			"Taranaki": null,
			"Tasman": null,
			"Waikato": null,
			"Wellington": null,
			"West Coast": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Nicaragua": {
		"code": "NI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ni-c33af5e3c1ebb00ea0fb53466f0ee0b69a808cf4c7f77fe1d5272a1233198cc3.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Niger": {
		"code": "NE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ne-36d7acf7411e112f62f261fd0ada6e4fe2852220f0725a0b9bd241c6427ba102.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Nigeria": {
		"code": "NG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ng-57301401e20c7ebd6687c930caa9c10c227b593bd38b15a217c45f3f2c36a166.svg",
		"label": "State",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "State",
		"provinces": ["Abia", "Abuja Federal Capital Territory", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
		"province_labels": {
			"Abia": "Abia",
			"Adamawa": "Adamawa",
			"Akwa Ibom": "Akwa Ibom",
			"Anambra": "Anambra",
			"Bauchi": "Bauchi",
			"Bayelsa": "Bayelsa",
			"Benue": "Benue",
			"Borno": "Borno",
			"Cross River": "Cross River",
			"Delta": "Delta",
			"Ebonyi": "Ebonyi",
			"Edo": "Edo",
			"Ekiti": "Ekiti",
			"Enugu": "Enugu",
			"Abuja Federal Capital Territory": "Federal Capital Territory",
			"Gombe": "Gombe",
			"Imo": "Imo",
			"Jigawa": "Jigawa",
			"Kaduna": "Kaduna",
			"Kano": "Kano",
			"Katsina": "Katsina",
			"Kebbi": "Kebbi",
			"Kogi": "Kogi",
			"Kwara": "Kwara",
			"Lagos": "Lagos",
			"Nasarawa": "Nasarawa",
			"Niger": "Niger",
			"Ogun": "Ogun",
			"Ondo": "Ondo",
			"Osun": "Osun",
			"Oyo": "Oyo",
			"Plateau": "Plateau",
			"Rivers": "Rivers",
			"Sokoto": "Sokoto",
			"Taraba": "Taraba",
			"Yobe": "Yobe",
			"Zamfara": "Zamfara"
		},
		"province_codes": {
			"Abia": "AB",
			"Abuja Federal Capital Territory": "FC",
			"Adamawa": "AD",
			"Akwa Ibom": "AK",
			"Anambra": "AN",
			"Bauchi": "BA",
			"Bayelsa": "BY",
			"Benue": "BE",
			"Borno": "BO",
			"Cross River": "CR",
			"Delta": "DE",
			"Ebonyi": "EB",
			"Edo": "ED",
			"Ekiti": "EK",
			"Enugu": "EN",
			"Gombe": "GO",
			"Imo": "IM",
			"Jigawa": "JI",
			"Kaduna": "KD",
			"Kano": "KN",
			"Katsina": "KT",
			"Kebbi": "KE",
			"Kogi": "KO",
			"Kwara": "KW",
			"Lagos": "LA",
			"Nasarawa": "NA",
			"Niger": "NI",
			"Ogun": "OG",
			"Ondo": "ON",
			"Osun": "OS",
			"Oyo": "OY",
			"Plateau": "PL",
			"Rivers": "RI",
			"Sokoto": "SO",
			"Taraba": "TA",
			"Yobe": "YO",
			"Zamfara": "ZA"
		},
		"province_alternate_names": {
			"Abia": null,
			"Abuja Federal Capital Territory": ["Abuja"],
			"Adamawa": null,
			"Akwa Ibom": null,
			"Anambra": null,
			"Bauchi": null,
			"Bayelsa": null,
			"Benue": null,
			"Borno": null,
			"Cross River": null,
			"Delta": null,
			"Ebonyi": null,
			"Edo": null,
			"Ekiti": null,
			"Enugu": null,
			"Gombe": null,
			"Imo": null,
			"Jigawa": null,
			"Kaduna": null,
			"Kano": null,
			"Katsina": null,
			"Kebbi": null,
			"Kogi": null,
			"Kwara": null,
			"Lagos": null,
			"Nasarawa": null,
			"Niger": null,
			"Ogun": null,
			"Ondo": null,
			"Osun": null,
			"Oyo": null,
			"Plateau": null,
			"Rivers": null,
			"Sokoto": null,
			"Taraba": null,
			"Yobe": null,
			"Zamfara": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "State",
		"checkout_zone_placeholder": "State"
	},
	"Niue": {
		"code": "NU",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/nu-7142fbe1478d82ebd2380fc0fe2acbadc34428bb4abc81776a5438094f7e8ac2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Norfolk Island": {
		"code": "NF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/nf-d73d4a2d8abc36919f3710b84e623ad689f3ce7db90ef418e507754240c85cab.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"North Macedonia": {
		"code": "MK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mk-9605dc33ee8848f82ec61c57f7e802f32137e6ca31caa907918f1edc44d9ba47.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Norway": {
		"code": "NO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/no-037c0f21f9ad53589902ddc411e836a94298641b2870ceba0bfac9ffee62352e.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Oman": {
		"code": "OM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/om-808a57ba4c58867066e263520e9d79f90e0c9d460687ab9a370160fb56e1c049.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Pakistan": {
		"code": "PK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pk-5d1ad05b80296a094512e6edbd43b27a96bef01c0f9852dd540b56debb61d18a.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Palestinian Territory, Occupied": {
		"code": "PS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ps-5ff1dd310f5ee66d301158ab56261ada3af2d99d26073023eaa09d5b8002d0b2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Panama": {
		"code": "PA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pa-ceb96947effb2596e74c37fa80a049626b71dee595bf21ba5754ac103ac4c476.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cs",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Bocas del Toro", "Chiriquí", "Coclé", "Colón", "Darién", "Emberá", "Herrera", "Kuna Yala", "Los Santos", "Ngöbe-Buglé", "Panamá", "Panamá Oeste", "Veraguas"],
		"province_labels": {
			"Bocas del Toro": "Bocas del Toro",
			"Chiriquí": "Chiriquí",
			"Coclé": "Coclé",
			"Colón": "Colón",
			"Darién": "Darién",
			"Emberá": "Emberá",
			"Kuna Yala": "Guna Yala",
			"Herrera": "Herrera",
			"Los Santos": "Los Santos",
			"Ngöbe-Buglé": "Ngöbe-Buglé",
			"Panamá": "Panamá",
			"Veraguas": "Veraguas",
			"Panamá Oeste": "West Panamá"
		},
		"province_codes": {
			"Bocas del Toro": "PA-1",
			"Chiriquí": "PA-4",
			"Coclé": "PA-2",
			"Colón": "PA-3",
			"Darién": "PA-5",
			"Emberá": "PA-EM",
			"Herrera": "PA-6",
			"Kuna Yala": "PA-KY",
			"Los Santos": "PA-7",
			"Ngöbe-Buglé": "PA-NB",
			"Panamá": "PA-8",
			"Panamá Oeste": "PA-10",
			"Veraguas": "PA-9"
		},
		"province_alternate_names": {
			"Bocas del Toro": null,
			"Chiriquí": ["Chiriqui"],
			"Coclé": ["Cocle"],
			"Colón": ["Colon"],
			"Darién": ["Darien"],
			"Emberá": ["Embera"],
			"Herrera": null,
			"Kuna Yala": null,
			"Los Santos": null,
			"Ngöbe-Buglé": ["Ngobe-Bugle"],
			"Panamá": ["Panama"],
			"Panamá Oeste": ["Panama Oeste"],
			"Veraguas": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Papua New Guinea": {
		"code": "PG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pg-647ab0c92d7f9f6a629d99658f5d956c8424d50eca562d4d33bf2911aa5c13f4.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Paraguay": {
		"code": "PY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/py-67ce02f858a28ad984018f57b2080ee3b45f62ee9fba1a7ffead412ccbd6c5be.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Peru": {
		"code": "PE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pe-0e5601aa50fdf7ab9f060114fd66def0f9b37b04177c5d043bb8fe46bef7f90a.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Amazonas", "Áncash", "Apurímac", "Arequipa", "Ayacucho", "Cajamarca", "Callao", "Cuzco", "Huancavelica", "Huánuco", "Ica", "Junín", "La Libertad", "Lambayeque", "Lima (departamento)", "Lima (provincia)", "Loreto", "Madre de Dios", "Moquegua", "Pasco", "Piura", "Puno", "San Martín", "Tacna", "Tumbes", "Ucayali"],
		"province_labels": {
			"Amazonas": "Amazonas",
			"Áncash": "Ancash",
			"Apurímac": "Apurímac",
			"Arequipa": "Arequipa",
			"Ayacucho": "Ayacucho",
			"Cajamarca": "Cajamarca",
			"Cuzco": "Cusco",
			"Callao": "El Callao",
			"Huancavelica": "Huancavelica",
			"Huánuco": "Huánuco",
			"Ica": "Ica",
			"Junín": "Junín",
			"La Libertad": "La Libertad",
			"Lambayeque": "Lambayeque",
			"Lima (provincia)": "Lima",
			"Lima (departamento)": "Lima Region",
			"Loreto": "Loreto",
			"Madre de Dios": "Madre de Dios",
			"Moquegua": "Moquegua",
			"Pasco": "Pasco",
			"Piura": "Piura",
			"Puno": "Puno",
			"San Martín": "San Martín",
			"Tacna": "Tacna",
			"Tumbes": "Tumbes",
			"Ucayali": "Ucayali"
		},
		"province_codes": {
			"Amazonas": "PE-AMA",
			"Áncash": "PE-ANC",
			"Apurímac": "PE-APU",
			"Arequipa": "PE-ARE",
			"Ayacucho": "PE-AYA",
			"Cajamarca": "PE-CAJ",
			"Callao": "PE-CAL",
			"Cuzco": "PE-CUS",
			"Huancavelica": "PE-HUV",
			"Huánuco": "PE-HUC",
			"Ica": "PE-ICA",
			"Junín": "PE-JUN",
			"La Libertad": "PE-LAL",
			"Lambayeque": "PE-LAM",
			"Lima (departamento)": "PE-LIM",
			"Lima (provincia)": "PE-LMA",
			"Loreto": "PE-LOR",
			"Madre de Dios": "PE-MDD",
			"Moquegua": "PE-MOQ",
			"Pasco": "PE-PAS",
			"Piura": "PE-PIU",
			"Puno": "PE-PUN",
			"San Martín": "PE-SAM",
			"Tacna": "PE-TAC",
			"Tumbes": "PE-TUM",
			"Ucayali": "PE-UCA"
		},
		"province_alternate_names": {
			"Amazonas": null,
			"Áncash": ["Ancash", "Ancash"],
			"Apurímac": ["Apurimac", "Apurimac"],
			"Arequipa": null,
			"Ayacucho": null,
			"Cajamarca": null,
			"Callao": null,
			"Cuzco": null,
			"Huancavelica": null,
			"Huánuco": ["Huanuco", "Huanuco"],
			"Ica": null,
			"Junín": ["Junin", "Junin"],
			"La Libertad": null,
			"Lambayeque": null,
			"Lima (departamento)": null,
			"Lima (provincia)": null,
			"Loreto": null,
			"Madre de Dios": null,
			"Moquegua": null,
			"Pasco": null,
			"Piura": null,
			"Puno": null,
			"San Martín": ["San Martin", "San Martin"],
			"Tacna": null,
			"Tumbes": null,
			"Ucayali": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Philippines": {
		"code": "PH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ph-b4958dc8963871a24b0ca6ddec26c436eeee34c0bf34e8e14f9717c708a2c606.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Abra", "Agusan del Norte", "Agusan del Sur", "Aklan", "Albay", "Antique", "Apayao", "Aurora", "Basilan", "Bataan", "Batanes", "Batangas", "Benguet", "Biliran", "Bohol", "Bukidnon", "Bulacan", "Cagayan", "Camarines Norte", "Camarines Sur", "Camiguin", "Capiz", "Catanduanes", "Cavite", "Cebu", "Cotabato", "Davao de Oro", "Davao del Norte", "Davao del Sur", "Davao Occidental", "Davao Oriental", "Dinagat Islands", "Eastern Samar", "Guimaras", "Ifugao", "Ilocos Norte", "Ilocos Sur", "Iloilo", "Isabela", "Kalinga", "La Union", "Laguna", "Lanao del Norte", "Lanao del Sur", "Leyte", "Maguindanao", "Marinduque", "Masbate", "Metro Manila", "Misamis Occidental", "Misamis Oriental", "Mountain Province", "Negros Occidental", "Negros Oriental", "Northern Samar", "Nueva Ecija", "Nueva Vizcaya", "Occidental Mindoro", "Oriental Mindoro", "Palawan", "Pampanga", "Pangasinan", "Quezon", "Quirino", "Rizal", "Romblon", "Samar", "Sarangani", "Siquijor", "Sorsogon", "South Cotabato", "Southern Leyte", "Sultan Kudarat", "Sulu", "Surigao del Norte", "Surigao del Sur", "Tarlac", "Tawi-Tawi", "Zambales", "Zamboanga del Norte", "Zamboanga del Sur", "Zamboanga Sibugay"],
		"province_labels": {
			"Abra": "Abra",
			"Agusan del Norte": "Agusan del Norte",
			"Agusan del Sur": "Agusan del Sur",
			"Aklan": "Aklan",
			"Albay": "Albay",
			"Antique": "Antique",
			"Apayao": "Apayao",
			"Aurora": "Aurora",
			"Basilan": "Basilan",
			"Bataan": "Bataan",
			"Batanes": "Batanes",
			"Batangas": "Batangas",
			"Benguet": "Benguet",
			"Biliran": "Biliran",
			"Bohol": "Bohol",
			"Bukidnon": "Bukidnon",
			"Bulacan": "Bulacan",
			"Cagayan": "Cagayan",
			"Camarines Norte": "Camarines Norte",
			"Camarines Sur": "Camarines Sur",
			"Camiguin": "Camiguin",
			"Capiz": "Capiz",
			"Catanduanes": "Catanduanes",
			"Cavite": "Cavite",
			"Cebu": "Cebu",
			"Davao de Oro": "Compostela Valley",
			"Cotabato": "Cotabato",
			"Davao Occidental": "Davao Occidental",
			"Davao Oriental": "Davao Oriental",
			"Davao del Norte": "Davao del Norte",
			"Davao del Sur": "Davao del Sur",
			"Dinagat Islands": "Dinagat Islands",
			"Eastern Samar": "Eastern Samar",
			"Guimaras": "Guimaras",
			"Ifugao": "Ifugao",
			"Ilocos Norte": "Ilocos Norte",
			"Ilocos Sur": "Ilocos Sur",
			"Iloilo": "Iloilo",
			"Isabela": "Isabela",
			"Kalinga": "Kalinga",
			"La Union": "La Union",
			"Laguna": "Laguna",
			"Lanao del Norte": "Lanao del Norte",
			"Lanao del Sur": "Lanao del Sur",
			"Leyte": "Leyte",
			"Maguindanao": "Maguindanao",
			"Marinduque": "Marinduque",
			"Masbate": "Masbate",
			"Metro Manila": "Metro Manila",
			"Misamis Occidental": "Misamis Occidental",
			"Misamis Oriental": "Misamis Oriental",
			"Mountain Province": "Mountain",
			"Negros Occidental": "Negros Occidental",
			"Negros Oriental": "Negros Oriental",
			"Northern Samar": "Northern Samar",
			"Nueva Ecija": "Nueva Ecija",
			"Nueva Vizcaya": "Nueva Vizcaya",
			"Occidental Mindoro": "Occidental Mindoro",
			"Oriental Mindoro": "Oriental Mindoro",
			"Palawan": "Palawan",
			"Pampanga": "Pampanga",
			"Pangasinan": "Pangasinan",
			"Quezon": "Quezon",
			"Quirino": "Quirino",
			"Rizal": "Rizal",
			"Romblon": "Romblon",
			"Samar": "Samar",
			"Sarangani": "Sarangani",
			"Siquijor": "Siquijor",
			"Sorsogon": "Sorsogon",
			"South Cotabato": "South Cotabato",
			"Southern Leyte": "Southern Leyte",
			"Sultan Kudarat": "Sultan Kudarat",
			"Sulu": "Sulu",
			"Surigao del Norte": "Surigao del Norte",
			"Surigao del Sur": "Surigao del Sur",
			"Tarlac": "Tarlac",
			"Tawi-Tawi": "Tawi-Tawi",
			"Zambales": "Zambales",
			"Zamboanga Sibugay": "Zamboanga Sibugay",
			"Zamboanga del Norte": "Zamboanga del Norte",
			"Zamboanga del Sur": "Zamboanga del Sur"
		},
		"province_codes": {
			"Abra": "PH-ABR",
			"Agusan del Norte": "PH-AGN",
			"Agusan del Sur": "PH-AGS",
			"Aklan": "PH-AKL",
			"Albay": "PH-ALB",
			"Antique": "PH-ANT",
			"Apayao": "PH-APA",
			"Aurora": "PH-AUR",
			"Basilan": "PH-BAS",
			"Bataan": "PH-BAN",
			"Batanes": "PH-BTN",
			"Batangas": "PH-BTG",
			"Benguet": "PH-BEN",
			"Biliran": "PH-BIL",
			"Bohol": "PH-BOH",
			"Bukidnon": "PH-BUK",
			"Bulacan": "PH-BUL",
			"Cagayan": "PH-CAG",
			"Camarines Norte": "PH-CAN",
			"Camarines Sur": "PH-CAS",
			"Camiguin": "PH-CAM",
			"Capiz": "PH-CAP",
			"Catanduanes": "PH-CAT",
			"Cavite": "PH-CAV",
			"Cebu": "PH-CEB",
			"Cotabato": "PH-NCO",
			"Davao de Oro": "PH-COM",
			"Davao del Norte": "PH-DAV",
			"Davao del Sur": "PH-DAS",
			"Davao Occidental": "PH-DVO",
			"Davao Oriental": "PH-DAO",
			"Dinagat Islands": "PH-DIN",
			"Eastern Samar": "PH-EAS",
			"Guimaras": "PH-GUI",
			"Ifugao": "PH-IFU",
			"Ilocos Norte": "PH-ILN",
			"Ilocos Sur": "PH-ILS",
			"Iloilo": "PH-ILI",
			"Isabela": "PH-ISA",
			"Kalinga": "PH-KAL",
			"La Union": "PH-LUN",
			"Laguna": "PH-LAG",
			"Lanao del Norte": "PH-LAN",
			"Lanao del Sur": "PH-LAS",
			"Leyte": "PH-LEY",
			"Maguindanao": "PH-MAG",
			"Marinduque": "PH-MAD",
			"Masbate": "PH-MAS",
			"Metro Manila": "PH-00",
			"Misamis Occidental": "PH-MSC",
			"Misamis Oriental": "PH-MSR",
			"Mountain Province": "PH-MOU",
			"Negros Occidental": "PH-NEC",
			"Negros Oriental": "PH-NER",
			"Northern Samar": "PH-NSA",
			"Nueva Ecija": "PH-NUE",
			"Nueva Vizcaya": "PH-NUV",
			"Occidental Mindoro": "PH-MDC",
			"Oriental Mindoro": "PH-MDR",
			"Palawan": "PH-PLW",
			"Pampanga": "PH-PAM",
			"Pangasinan": "PH-PAN",
			"Quezon": "PH-QUE",
			"Quirino": "PH-QUI",
			"Rizal": "PH-RIZ",
			"Romblon": "PH-ROM",
			"Samar": "PH-WSA",
			"Sarangani": "PH-SAR",
			"Siquijor": "PH-SIG",
			"Sorsogon": "PH-SOR",
			"South Cotabato": "PH-SCO",
			"Southern Leyte": "PH-SLE",
			"Sultan Kudarat": "PH-SUK",
			"Sulu": "PH-SLU",
			"Surigao del Norte": "PH-SUN",
			"Surigao del Sur": "PH-SUR",
			"Tarlac": "PH-TAR",
			"Tawi-Tawi": "PH-TAW",
			"Zambales": "PH-ZMB",
			"Zamboanga del Norte": "PH-ZAN",
			"Zamboanga del Sur": "PH-ZAS",
			"Zamboanga Sibugay": "PH-ZSI"
		},
		"province_alternate_names": {
			"Abra": null,
			"Agusan del Norte": null,
			"Agusan del Sur": null,
			"Aklan": null,
			"Albay": null,
			"Antique": null,
			"Apayao": null,
			"Aurora": null,
			"Basilan": null,
			"Bataan": null,
			"Batanes": null,
			"Batangas": null,
			"Benguet": null,
			"Biliran": null,
			"Bohol": null,
			"Bukidnon": null,
			"Bulacan": null,
			"Cagayan": null,
			"Camarines Norte": null,
			"Camarines Sur": null,
			"Camiguin": null,
			"Capiz": null,
			"Catanduanes": null,
			"Cavite": null,
			"Cebu": null,
			"Cotabato": null,
			"Davao de Oro": null,
			"Davao del Norte": null,
			"Davao del Sur": null,
			"Davao Occidental": null,
			"Davao Oriental": null,
			"Dinagat Islands": null,
			"Eastern Samar": null,
			"Guimaras": null,
			"Ifugao": null,
			"Ilocos Norte": null,
			"Ilocos Sur": null,
			"Iloilo": null,
			"Isabela": null,
			"Kalinga": null,
			"La Union": null,
			"Laguna": null,
			"Lanao del Norte": null,
			"Lanao del Sur": null,
			"Leyte": null,
			"Maguindanao": null,
			"Marinduque": null,
			"Masbate": null,
			"Metro Manila": null,
			"Misamis Occidental": null,
			"Misamis Oriental": null,
			"Mountain Province": null,
			"Negros Occidental": null,
			"Negros Oriental": null,
			"Northern Samar": null,
			"Nueva Ecija": null,
			"Nueva Vizcaya": null,
			"Occidental Mindoro": null,
			"Oriental Mindoro": null,
			"Palawan": null,
			"Pampanga": null,
			"Pangasinan": null,
			"Quezon": null,
			"Quirino": null,
			"Rizal": null,
			"Romblon": null,
			"Samar": null,
			"Sarangani": null,
			"Siquijor": null,
			"Sorsogon": null,
			"South Cotabato": null,
			"Southern Leyte": null,
			"Sultan Kudarat": null,
			"Sulu": null,
			"Surigao del Norte": null,
			"Surigao del Sur": null,
			"Tarlac": null,
			"Tawi-Tawi": null,
			"Zambales": null,
			"Zamboanga del Norte": null,
			"Zamboanga del Sur": null,
			"Zamboanga Sibugay": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Pitcairn": {
		"code": "PN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pn-2bcc3ca847019caa228a5819854684d463d2b60f25359dd49ceb47dc66f9ab28.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Poland": {
		"code": "PL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pl-ca69810c60aacd2e0d17005df7ea4a2318fafa7385b580e33cdfbdb16fc3e2f1.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Portugal": {
		"code": "PT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pt-6607776592531b9043b8733f61f360acee1731a1ae6b797583ec6f4b3b2843dc.svg",
		"label": "Region",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["Açores", "Aveiro", "Beja", "Braga", "Bragança", "Castelo Branco", "Coimbra", "Évora", "Faro", "Guarda", "Leiria", "Lisboa", "Madeira", "Portalegre", "Porto", "Santarém", "Setúbal", "Viana do Castelo", "Vila Real", "Viseu"],
		"province_labels": {
			"Aveiro": "Aveiro",
			"Açores": "Azores",
			"Beja": "Beja",
			"Braga": "Braga",
			"Bragança": "Bragança",
			"Castelo Branco": "Castelo Branco",
			"Coimbra": "Coimbra",
			"Évora": "Évora",
			"Faro": "Faro",
			"Guarda": "Guarda",
			"Leiria": "Leiria",
			"Lisboa": "Lisbon",
			"Madeira": "Madeira",
			"Portalegre": "Portalegre",
			"Porto": "Porto",
			"Santarém": "Santarém",
			"Setúbal": "Setúbal",
			"Viana do Castelo": "Viana do Castelo",
			"Vila Real": "Vila Real",
			"Viseu": "Viseu"
		},
		"province_codes": {
			"Açores": "PT-20",
			"Aveiro": "PT-01",
			"Beja": "PT-02",
			"Braga": "PT-03",
			"Bragança": "PT-04",
			"Castelo Branco": "PT-05",
			"Coimbra": "PT-06",
			"Évora": "PT-07",
			"Faro": "PT-08",
			"Guarda": "PT-09",
			"Leiria": "PT-10",
			"Lisboa": "PT-11",
			"Madeira": "PT-30",
			"Portalegre": "PT-12",
			"Porto": "PT-13",
			"Santarém": "PT-14",
			"Setúbal": "PT-15",
			"Viana do Castelo": "PT-16",
			"Vila Real": "PT-17",
			"Viseu": "PT-18"
		},
		"province_alternate_names": {
			"Açores": ["Acores"],
			"Aveiro": null,
			"Beja": null,
			"Braga": null,
			"Bragança": ["Braganca"],
			"Castelo Branco": null,
			"Coimbra": null,
			"Évora": ["Evora"],
			"Faro": null,
			"Guarda": null,
			"Leiria": null,
			"Lisboa": null,
			"Madeira": null,
			"Portalegre": null,
			"Porto": null,
			"Santarém": ["Santarem"],
			"Setúbal": ["Setubal"],
			"Viana do Castelo": null,
			"Vila Real": null,
			"Viseu": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Qatar": {
		"code": "QA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/qa-8ee0871f5fa6f32717beeef3b9a58d4e45c34583ee2934ee752b803fa88456b9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Republic of Cameroon": {
		"code": "CM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/cm-f9fdc4bee29cf5536258eeeb8ad6be79b014a96724a24faa7edb3d5b240cc682.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Reunion": {
		"code": "RE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/re-53a8a7d8c53d71036c24aebb45e0192f98cad78b4ea3cfdeb695bd2f9bf2b7f5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Romania": {
		"code": "RO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ro-15755637dd265e88f60a53a6e62d8daf8ad893dfa4e42f51085b9c778f0d2e91.svg",
		"label": "County",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "County",
		"provinces": ["Alba", "Arad", "Argeș", "Bacău", "Bihor", "Bistrița-Năsăud", "Botoșani", "Brașov", "Brăila", "București", "Buzău", "Călărași", "Caraș-Severin", "Cluj", "Constanța", "Covasna", "Dâmbovița", "Dolj", "Galați", "Giurgiu", "Gorj", "Harghita", "Hunedoara", "Iași", "Ialomița", "Ilfov", "Maramureș", "Mehedinți", "Mureș", "Neamț", "Olt", "Prahova", "Sălaj", "Satu Mare", "Sibiu", "Suceava", "Teleorman", "Timiș", "Tulcea", "Vâlcea", "Vaslui", "Vrancea"],
		"province_labels": {
			"Alba": "Alba",
			"Arad": "Arad",
			"Argeș": "Argeș",
			"Bacău": "Bacău",
			"Bihor": "Bihor",
			"Bistrița-Năsăud": "Bistriţa-Năsăud",
			"Botoșani": "Botoşani",
			"Brăila": "Brăila",
			"Brașov": "Braşov",
			"București": "Bucharest",
			"Buzău": "Buzău",
			"Caraș-Severin": "Caraș-Severin",
			"Cluj": "Cluj",
			"Constanța": "Constanța",
			"Covasna": "Covasna",
			"Călărași": "Călărași",
			"Dolj": "Dolj",
			"Dâmbovița": "Dâmbovița",
			"Galați": "Galați",
			"Giurgiu": "Giurgiu",
			"Gorj": "Gorj",
			"Harghita": "Harghita",
			"Hunedoara": "Hunedoara",
			"Ialomița": "Ialomița",
			"Iași": "Iași",
			"Ilfov": "Ilfov",
			"Maramureș": "Maramureş",
			"Mehedinți": "Mehedinți",
			"Mureș": "Mureş",
			"Neamț": "Neamţ",
			"Olt": "Olt",
			"Prahova": "Prahova",
			"Sălaj": "Sălaj",
			"Satu Mare": "Satu Mare",
			"Sibiu": "Sibiu",
			"Suceava": "Suceava",
			"Teleorman": "Teleorman",
			"Timiș": "Timiș",
			"Tulcea": "Tulcea",
			"Vâlcea": "Vâlcea",
			"Vaslui": "Vaslui",
			"Vrancea": "Vrancea"
		},
		"province_codes": {
			"Alba": "AB",
			"Arad": "AR",
			"Argeș": "AG",
			"Bacău": "BC",
			"Bihor": "BH",
			"Bistrița-Năsăud": "BN",
			"Botoșani": "BT",
			"Brașov": "BV",
			"Brăila": "BR",
			"București": "B",
			"Buzău": "BZ",
			"Călărași": "CL",
			"Caraș-Severin": "CS",
			"Cluj": "CJ",
			"Constanța": "CT",
			"Covasna": "CV",
			"Dâmbovița": "DB",
			"Dolj": "DJ",
			"Galați": "GL",
			"Giurgiu": "GR",
			"Gorj": "GJ",
			"Harghita": "HR",
			"Hunedoara": "HD",
			"Iași": "IS",
			"Ialomița": "IL",
			"Ilfov": "IF",
			"Maramureș": "MM",
			"Mehedinți": "MH",
			"Mureș": "MS",
			"Neamț": "NT",
			"Olt": "OT",
			"Prahova": "PH",
			"Sălaj": "SJ",
			"Satu Mare": "SM",
			"Sibiu": "SB",
			"Suceava": "SV",
			"Teleorman": "TR",
			"Timiș": "TM",
			"Tulcea": "TL",
			"Vâlcea": "VL",
			"Vaslui": "VS",
			"Vrancea": "VN"
		},
		"province_alternate_names": {
			"Alba": null,
			"Arad": null,
			"Argeș": ["Arge?"],
			"Bacău": ["Bacau"],
			"Bihor": null,
			"Bistrița-Năsăud": ["Bistri?a-Nasaud"],
			"Botoșani": ["Boto?ani"],
			"Brașov": ["Bra?ov"],
			"Brăila": ["Braila"],
			"București": ["Bucure?ti"],
			"Buzău": ["Buzau"],
			"Călărași": ["Calara?i"],
			"Caraș-Severin": ["Cara?-Severin"],
			"Cluj": null,
			"Constanța": ["Constan?a"],
			"Covasna": null,
			"Dâmbovița": ["Dambovi?a"],
			"Dolj": null,
			"Galați": ["Gala?i"],
			"Giurgiu": null,
			"Gorj": null,
			"Harghita": null,
			"Hunedoara": null,
			"Iași": ["Ia?i"],
			"Ialomița": ["Ialomi?a"],
			"Ilfov": null,
			"Maramureș": ["Maramure?"],
			"Mehedinți": ["Mehedin?i"],
			"Mureș": ["Mure?"],
			"Neamț": ["Neam?"],
			"Olt": null,
			"Prahova": null,
			"Sălaj": ["Salaj"],
			"Satu Mare": null,
			"Sibiu": null,
			"Suceava": null,
			"Teleorman": null,
			"Timiș": ["Timi?"],
			"Tulcea": null,
			"Vâlcea": ["Valcea"],
			"Vaslui": null,
			"Vrancea": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "County",
		"checkout_zone_placeholder": "County"
	},
	"Rwanda": {
		"code": "RW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/rw-b754c3c7705c8fe8778dadfa53d699fe8225b070aa6d698e10ce2e14cb0ed9c9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Saint Barthélemy": {
		"code": "BL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/bl-53a8a7d8c53d71036c24aebb45e0192f98cad78b4ea3cfdeb695bd2f9bf2b7f5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Saint Helena": {
		"code": "SH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sh-552b60ab5b2ab564591cf7591ec641e8eb071331603154e72da5f5ab80f2784a.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Saint Kitts And Nevis": {
		"code": "KN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/kn-0694b6730f80c2ec3f9ca57a83238f58185dd35b1172a2d3880820fd0d0b204d.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Saint Lucia": {
		"code": "LC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/lc-bc26d1a97a4c2c573e0410dc094fd332dc750579895013c640bed592ab2d768c.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Saint Martin": {
		"code": "MF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/mf-10d09cbc2a8b2219da141bbacc940ec8f45a55b36b0dd8f92d07c6c93331f85f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Saint Pierre And Miquelon": {
		"code": "PM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/pm-53a8a7d8c53d71036c24aebb45e0192f98cad78b4ea3cfdeb695bd2f9bf2b7f5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Samoa": {
		"code": "WS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ws-ed786f3d202d03dc7b6e6231733f2bbf617e7555aacc7013af7fd7d50299ff74.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"San Marino": {
		"code": "SM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sm-b645203f31e0e6dfd5e43e79d6acf49a95ee8db79d400dd2c701434d1b86e453.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Sao Tome And Principe": {
		"code": "ST",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/st-2a60ae15e8283bf8b4c7cc10010134f9879a190f5d13908b06363d7dafb312bd.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Saudi Arabia": {
		"code": "SA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sa-fcd2ba12b40a6274fcc752f0706cbdca180c32b54b16aef548b71eaaa08c789f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Senegal": {
		"code": "SN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sn-0fb14fcca74b1a937d3a0cc8212cd1aff8e7ea84d57d2e5531e77aea5eb8e5ca.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Serbia": {
		"code": "RS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/rs-5787eba463522ac15c429e67c02fd8236d5d54022976e21069bd7cb257aa388b.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Seychelles": {
		"code": "SC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sc-f2daa196b5cd641ce75ba77827f0409ae4e70ce8ef002e63527447faed966ac9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Sierra Leone": {
		"code": "SL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sl-84063287da3e78722221088294e0712687a1d1253f44a64d7af08eb7f78861f7.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Singapore": {
		"code": "SG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sg-5fdb715a18e2ea6f9708451ed8e6ffb76a4217be74140d367764fc2bc095983f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Sint Maarten": {
		"code": "SX",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sx-46763d9e7c08598233a9704bdd61add3a321e92351a42ef7f27aed769eb91fc3.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Slovakia": {
		"code": "SK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sk-7b588350e9e58c72c948ad3d24c2e748aab007a0e07a7b672073ad3a58d5991c.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Slovenia": {
		"code": "SI",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/si-8febfd67858cd45d6bd4c044688021b5bdc4ccbe75decd4d34f0415f9a8c5322.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Solomon Islands": {
		"code": "SB",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sb-fc5ef4948d6d695b1bb614a61fba0a3562ad39d49409898509a7e9d98c410f71.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Somalia": {
		"code": "SO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/so-2cb90d8922733b823d9cd3de361f63f0d8f61335157978547d9718305c652826.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"South Africa": {
		"code": "ZA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/za-2bc4ce21e2f155186022d608ae17af208ac7929dae2975c8e8d3fe0567ecf761.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape"],
		"province_labels": {
			"Eastern Cape": "Eastern Cape",
			"Free State": "Free State",
			"Gauteng": "Gauteng",
			"KwaZulu-Natal": "KwaZulu-Natal",
			"Limpopo": "Limpopo",
			"Mpumalanga": "Mpumalanga",
			"North West": "North West",
			"Northern Cape": "Northern Cape",
			"Western Cape": "Western Cape"
		},
		"province_codes": {
			"Eastern Cape": "EC",
			"Free State": "FS",
			"Gauteng": "GT",
			"KwaZulu-Natal": "NL",
			"Limpopo": "LP",
			"Mpumalanga": "MP",
			"North West": "NW",
			"Northern Cape": "NC",
			"Western Cape": "WC"
		},
		"province_alternate_names": {
			"Eastern Cape": null,
			"Free State": null,
			"Gauteng": null,
			"KwaZulu-Natal": null,
			"Limpopo": null,
			"Mpumalanga": null,
			"North West": null,
			"Northern Cape": null,
			"Western Cape": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"South Georgia And The South Sandwich Islands": {
		"code": "GS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gs-cd2b98530322bea8861c74fcfe2d292454ecdb905ec2622387e48bf7d43346b2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"South Korea": {
		"code": "KR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/kr-226f316d7ae7a184e23d015e3982bd9d685ac8071fc2ee19906d0f6031489f19.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "N_p_c_sc_a_a",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Busan", "Chungbuk", "Chungnam", "Daegu", "Daejeon", "Gangwon", "Gwangju", "Gyeongbuk", "Gyeonggi", "Gyeongnam", "Incheon", "Jeju", "Jeonbuk", "Jeonnam", "Sejong", "Seoul", "Ulsan"],
		"province_labels": {
			"Busan": "Busan",
			"Daegu": "Daegu",
			"Daejeon": "Daejeon",
			"Gangwon": "Gangwon",
			"Gwangju": "Gwangju City",
			"Gyeonggi": "Gyeonggi",
			"Incheon": "Incheon",
			"Jeju": "Jeju",
			"Chungbuk": "North Chungcheong",
			"Gyeongbuk": "North Gyeongsang",
			"Jeonbuk": "North Jeolla",
			"Sejong": "Sejong",
			"Seoul": "Seoul",
			"Chungnam": "South Chungcheong",
			"Gyeongnam": "South Gyeongsang",
			"Jeonnam": "South Jeolla",
			"Ulsan": "Ulsan"
		},
		"province_codes": {
			"Busan": "KR-26",
			"Chungbuk": "KR-43",
			"Chungnam": "KR-44",
			"Daegu": "KR-27",
			"Daejeon": "KR-30",
			"Gangwon": "KR-42",
			"Gwangju": "KR-29",
			"Gyeongbuk": "KR-47",
			"Gyeonggi": "KR-41",
			"Gyeongnam": "KR-48",
			"Incheon": "KR-28",
			"Jeju": "KR-49",
			"Jeonbuk": "KR-45",
			"Jeonnam": "KR-46",
			"Sejong": "KR-50",
			"Seoul": "KR-11",
			"Ulsan": "KR-31"
		},
		"province_alternate_names": {
			"Busan": null,
			"Chungbuk": null,
			"Chungnam": null,
			"Daegu": null,
			"Daejeon": null,
			"Gangwon": null,
			"Gwangju": null,
			"Gyeongbuk": null,
			"Gyeonggi": null,
			"Gyeongnam": null,
			"Incheon": null,
			"Jeju": null,
			"Jeonbuk": null,
			"Jeonnam": null,
			"Sejong": null,
			"Seoul": null,
			"Ulsan": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"South Sudan": {
		"code": "SS",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ss-b49e661cf296c152618a52366f684416abf90be360cb507d8c783c7be78647bb.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Spain": {
		"code": "ES",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/es-65865b592449f3b8d056283310c88f3bbfc439a23ff1df1a25c811b07a54f1e8.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["A Coruña", "Álava", "Albacete", "Alicante", "Almería", "Asturias", "Ávila", "Badajoz", "Balears", "Barcelona", "Burgos", "Cáceres", "Cádiz", "Cantabria", "Castellón", "Ceuta", "Ciudad Real", "Córdoba", "Cuenca", "Girona", "Granada", "Guadalajara", "Guipúzcoa", "Huelva", "Huesca", "Jaén", "La Rioja", "Las Palmas", "León", "Lleida", "Lugo", "Madrid", "Málaga", "Melilla", "Murcia", "Navarra", "Ourense", "Palencia", "Pontevedra", "Salamanca", "Santa Cruz de Tenerife", "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "Vizcaya", "Zamora", "Zaragoza"],
		"province_labels": {
			"A Coruña": "A Coruña",
			"Álava": "Álava",
			"Albacete": "Albacete",
			"Alicante": "Alicante",
			"Almería": "Almería",
			"Asturias": "Asturias Province",
			"Ávila": "Ávila",
			"Badajoz": "Badajoz",
			"Balears": "Balears Province",
			"Barcelona": "Barcelona",
			"Vizcaya": "Biscay",
			"Burgos": "Burgos",
			"Cáceres": "Cáceres",
			"Cádiz": "Cádiz",
			"Cantabria": "Cantabria Province",
			"Castellón": "Castellón",
			"Ceuta": "Ceuta",
			"Ciudad Real": "Ciudad Real",
			"Córdoba": "Córdoba",
			"Cuenca": "Cuenca",
			"Guipúzcoa": "Gipuzkoa",
			"Girona": "Girona",
			"Granada": "Granada",
			"Guadalajara": "Guadalajara",
			"Huelva": "Huelva",
			"Huesca": "Huesca",
			"Jaén": "Jaén",
			"La Rioja": "La Rioja Province",
			"Las Palmas": "Las Palmas",
			"León": "León",
			"Lleida": "Lleida",
			"Lugo": "Lugo",
			"Madrid": "Madrid Province",
			"Málaga": "Málaga",
			"Melilla": "Melilla",
			"Murcia": "Murcia",
			"Navarra": "Navarra",
			"Ourense": "Ourense",
			"Palencia": "Palencia",
			"Pontevedra": "Pontevedra",
			"Salamanca": "Salamanca",
			"Santa Cruz de Tenerife": "Santa Cruz de Tenerife",
			"Segovia": "Segovia",
			"Sevilla": "Seville",
			"Soria": "Soria",
			"Tarragona": "Tarragona",
			"Teruel": "Teruel",
			"Toledo": "Toledo",
			"Valencia": "Valencia",
			"Valladolid": "Valladolid",
			"Zamora": "Zamora",
			"Zaragoza": "Zaragoza"
		},
		"province_codes": {
			"A Coruña": "C",
			"Álava": "VI",
			"Albacete": "AB",
			"Alicante": "A",
			"Almería": "AL",
			"Asturias": "O",
			"Ávila": "AV",
			"Badajoz": "BA",
			"Balears": "PM",
			"Barcelona": "B",
			"Burgos": "BU",
			"Cáceres": "CC",
			"Cádiz": "CA",
			"Cantabria": "S",
			"Castellón": "CS",
			"Ceuta": "CE",
			"Ciudad Real": "CR",
			"Córdoba": "CO",
			"Cuenca": "CU",
			"Girona": "GI",
			"Granada": "GR",
			"Guadalajara": "GU",
			"Guipúzcoa": "SS",
			"Huelva": "H",
			"Huesca": "HU",
			"Jaén": "J",
			"La Rioja": "LO",
			"Las Palmas": "GC",
			"León": "LE",
			"Lleida": "L",
			"Lugo": "LU",
			"Madrid": "M",
			"Málaga": "MA",
			"Melilla": "ML",
			"Murcia": "MU",
			"Navarra": "NA",
			"Ourense": "OR",
			"Palencia": "P",
			"Pontevedra": "PO",
			"Salamanca": "SA",
			"Santa Cruz de Tenerife": "TF",
			"Segovia": "SG",
			"Sevilla": "SE",
			"Soria": "SO",
			"Tarragona": "T",
			"Teruel": "TE",
			"Toledo": "TO",
			"Valencia": "V",
			"Valladolid": "VA",
			"Vizcaya": "BI",
			"Zamora": "ZA",
			"Zaragoza": "Z"
		},
		"province_alternate_names": {
			"A Coruña": ["A Coruna"],
			"Álava": ["Alava", "Araba"],
			"Albacete": null,
			"Alicante": null,
			"Almería": ["Almeria"],
			"Asturias": ["Principado de Asturias"],
			"Ávila": ["Avila"],
			"Badajoz": null,
			"Balears": ["Baleares", "Illes Balears", "Islas Baleares"],
			"Barcelona": null,
			"Burgos": null,
			"Cáceres": ["Caceres"],
			"Cádiz": ["Cadiz"],
			"Cantabria": null,
			"Castellón": ["Castellon", "Castelló", "Castello"],
			"Ceuta": null,
			"Ciudad Real": ["Cdad. Real"],
			"Córdoba": ["Cordoba", "Cordova"],
			"Cuenca": null,
			"Girona": ["Gerona"],
			"Granada": null,
			"Guadalajara": null,
			"Guipúzcoa": ["Guipuzcoa", "Gipuzkoa"],
			"Huelva": null,
			"Huesca": ["Uesca", "Osca"],
			"Jaén": ["Jaen"],
			"La Rioja": null,
			"Las Palmas": null,
			"León": ["Leon"],
			"Lleida": ["Lérida", "Lerida"],
			"Lugo": null,
			"Madrid": ["Comunidad de Madrid", "Community of Madrid"],
			"Málaga": ["Malaga"],
			"Melilla": null,
			"Murcia": ["Región de Murcia", "Region de Murcia"],
			"Navarra": ["Nafarroa", "Navarre"],
			"Ourense": null,
			"Palencia": null,
			"Pontevedra": null,
			"Salamanca": null,
			"Santa Cruz de Tenerife": ["Santa Cruz"],
			"Segovia": null,
			"Sevilla": ["Seville"],
			"Soria": null,
			"Tarragona": null,
			"Teruel": null,
			"Toledo": null,
			"Valencia": ["València"],
			"Valladolid": null,
			"Vizcaya": ["Biscay", "Bizkaia"],
			"Zamora": null,
			"Zaragoza": ["Saragossa"]
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Sri Lanka": {
		"code": "LK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/lk-32c19b7c89621aa502cfa10d9ac68bac79aff958dec7a36577aeb25000114ec1.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"St. Vincent": {
		"code": "VC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/vc-56c6993a134c703097809cafaace9c453980f968219454d41487644bfc865256.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Sudan": {
		"code": "SD",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sd-9fdbc80d9c14c98b5326e45e2e54ee336caa91935f318b6658fa02bd455e28f4.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Suriname": {
		"code": "SR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sr-75625d0edd7b19901ec4f72c023f389fa8b97913bb2cd2fa77819942fc7a4fe2.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Svalbard And Jan Mayen": {
		"code": "SJ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sj-0cc92b26396ffd50b4c4e7aaafc1e1bbdf362cb56776721cf33053b936edd1da.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Sweden": {
		"code": "SE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/se-8dd8cf5605b332f5a7abcc1ac83452c8f22ca5befb74160a835f0ffde46bfe81.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Switzerland": {
		"code": "CH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ch-ac08fa33836b67eb7fbcaad7a0244a685a2dd367555f34de139f668a9f6c7885.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Syria": {
		"code": "SY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/sy-f4d88efb4e76b18f1596ce1153462d530ff46d92bcd7a5e82b45eba279aa8144.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Taiwan": {
		"code": "TW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tw-526a10ea3b6b5e10f2b4f503cda2934bda6ecd6f6893db9220dd6142cb29f346.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Tajikistan": {
		"code": "TJ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tj-9dc0cc9585d29dee01fe90ca31a0c577dea714393b1e38b0cba65104a983d820.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Tanzania, United Republic Of": {
		"code": "TZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tz-c3022d5c1c240c83479ffb29f575ba787ccb9e28143daf98cba002a1fb1757d5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Thailand": {
		"code": "TH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/th-ffe662e5a63774ffd37330c5a5b08336e788e68148c2f63e9bdc8ab9d98c9f88.svg",
		"label": "Province",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "Province",
		"provinces": ["Amnat Charoen", "Ang Thong", "Bangkok", "Bueng Kan", "Buriram", "Chachoengsao", "Chai Nat", "Chaiyaphum", "Chanthaburi", "Chiang Mai", "Chiang Rai", "Chon Buri", "Chumphon", "Kalasin", "Kamphaeng Phet", "Kanchanaburi", "Khon Kaen", "Krabi", "Lampang", "Lamphun", "Loei", "Lopburi", "Mae Hong Son", "Maha Sarakham", "Mukdahan", "Nakhon Nayok", "Nakhon Pathom", "Nakhon Phanom", "Nakhon Ratchasima", "Nakhon Sawan", "Nakhon Si Thammarat", "Nan", "Narathiwat", "Nong Bua Lam Phu", "Nong Khai", "Nonthaburi", "Pathum Thani", "Pattani", "Pattaya", "Phangnga", "Phatthalung", "Phayao", "Phetchabun", "Phetchaburi", "Phichit", "Phitsanulok", "Phra Nakhon Si Ayutthaya", "Phrae", "Phuket", "Prachin Buri", "Prachuap Khiri Khan", "Ranong", "Ratchaburi", "Rayong", "Roi Et", "Sa Kaeo", "Sakon Nakhon", "Samut Prakan", "Samut Sakhon", "Samut Songkhram", "Saraburi", "Satun", "Sing Buri", "Sisaket", "Songkhla", "Sukhothai", "Suphan Buri", "Surat Thani", "Surin", "Tak", "Trang", "Trat", "Ubon Ratchathani", "Udon Thani", "Uthai Thani", "Uttaradit", "Yala", "Yasothon"],
		"province_labels": {
			"Amnat Charoen": "Amnat Charoen",
			"Ang Thong": "Ang Thong",
			"Bangkok": "Bangkok",
			"Bueng Kan": "Bueng Kan",
			"Buriram": "Buri Ram",
			"Chachoengsao": "Chachoengsao",
			"Chai Nat": "Chai Nat",
			"Chaiyaphum": "Chaiyaphum",
			"Chanthaburi": "Chanthaburi",
			"Chiang Mai": "Chiang Mai",
			"Chiang Rai": "Chiang Rai",
			"Chon Buri": "Chon Buri",
			"Chumphon": "Chumphon",
			"Kalasin": "Kalasin",
			"Kamphaeng Phet": "Kamphaeng Phet",
			"Kanchanaburi": "Kanchanaburi",
			"Khon Kaen": "Khon Kaen",
			"Krabi": "Krabi",
			"Lampang": "Lampang",
			"Lamphun": "Lamphun",
			"Loei": "Loei",
			"Lopburi": "Lopburi",
			"Mae Hong Son": "Mae Hong Son",
			"Maha Sarakham": "Maha Sarakham",
			"Mukdahan": "Mukdahan",
			"Nakhon Nayok": "Nakhon Nayok",
			"Nakhon Pathom": "Nakhon Pathom",
			"Nakhon Phanom": "Nakhon Phanom",
			"Nakhon Ratchasima": "Nakhon Ratchasima",
			"Nakhon Sawan": "Nakhon Sawan",
			"Nakhon Si Thammarat": "Nakhon Si Thammarat",
			"Nan": "Nan",
			"Narathiwat": "Narathiwat",
			"Nong Bua Lam Phu": "Nong Bua Lam Phu",
			"Nong Khai": "Nong Khai",
			"Nonthaburi": "Nonthaburi",
			"Pathum Thani": "Pathum Thani",
			"Pattani": "Pattani",
			"Pattaya": "Pattaya",
			"Phangnga": "Phang Nga",
			"Phatthalung": "Phatthalung",
			"Phayao": "Phayao",
			"Phetchabun": "Phetchabun",
			"Phetchaburi": "Phetchaburi",
			"Phichit": "Phichit",
			"Phitsanulok": "Phitsanulok",
			"Phra Nakhon Si Ayutthaya": "Phra Nakhon Si Ayutthaya",
			"Phrae": "Phrae",
			"Phuket": "Phuket",
			"Prachin Buri": "Prachin Buri",
			"Prachuap Khiri Khan": "Prachuap Khiri Khan",
			"Ranong": "Ranong",
			"Ratchaburi": "Ratchaburi",
			"Rayong": "Rayong",
			"Roi Et": "Roi Et",
			"Sa Kaeo": "Sa Kaeo",
			"Sakon Nakhon": "Sakon Nakhon",
			"Samut Prakan": "Samut Prakan",
			"Samut Sakhon": "Samut Sakhon",
			"Samut Songkhram": "Samut Songkhram",
			"Saraburi": "Saraburi",
			"Satun": "Satun",
			"Sisaket": "Si Sa Ket",
			"Sing Buri": "Sing Buri",
			"Songkhla": "Songkhla",
			"Sukhothai": "Sukhothai",
			"Suphan Buri": "Suphanburi",
			"Surat Thani": "Surat Thani",
			"Surin": "Surin",
			"Tak": "Tak",
			"Trang": "Trang",
			"Trat": "Trat",
			"Ubon Ratchathani": "Ubon Ratchathani",
			"Udon Thani": "Udon Thani",
			"Uthai Thani": "Uthai Thani",
			"Uttaradit": "Uttaradit",
			"Yala": "Yala",
			"Yasothon": "Yasothon"
		},
		"province_codes": {
			"Amnat Charoen": "TH-37",
			"Ang Thong": "TH-15",
			"Bangkok": "TH-10",
			"Bueng Kan": "TH-38",
			"Buriram": "TH-31",
			"Chachoengsao": "TH-24",
			"Chai Nat": "TH-18",
			"Chaiyaphum": "TH-36",
			"Chanthaburi": "TH-22",
			"Chiang Mai": "TH-50",
			"Chiang Rai": "TH-57",
			"Chon Buri": "TH-20",
			"Chumphon": "TH-86",
			"Kalasin": "TH-46",
			"Kamphaeng Phet": "TH-62",
			"Kanchanaburi": "TH-71",
			"Khon Kaen": "TH-40",
			"Krabi": "TH-81",
			"Lampang": "TH-52",
			"Lamphun": "TH-51",
			"Loei": "TH-42",
			"Lopburi": "TH-16",
			"Mae Hong Son": "TH-58",
			"Maha Sarakham": "TH-44",
			"Mukdahan": "TH-49",
			"Nakhon Nayok": "TH-26",
			"Nakhon Pathom": "TH-73",
			"Nakhon Phanom": "TH-48",
			"Nakhon Ratchasima": "TH-30",
			"Nakhon Sawan": "TH-60",
			"Nakhon Si Thammarat": "TH-80",
			"Nan": "TH-55",
			"Narathiwat": "TH-96",
			"Nong Bua Lam Phu": "TH-39",
			"Nong Khai": "TH-43",
			"Nonthaburi": "TH-12",
			"Pathum Thani": "TH-13",
			"Pattani": "TH-94",
			"Pattaya": "TH-S",
			"Phangnga": "TH-82",
			"Phatthalung": "TH-93",
			"Phayao": "TH-56",
			"Phetchabun": "TH-67",
			"Phetchaburi": "TH-76",
			"Phichit": "TH-66",
			"Phitsanulok": "TH-65",
			"Phra Nakhon Si Ayutthaya": "TH-14",
			"Phrae": "TH-54",
			"Phuket": "TH-83",
			"Prachin Buri": "TH-25",
			"Prachuap Khiri Khan": "TH-77",
			"Ranong": "TH-85",
			"Ratchaburi": "TH-70",
			"Rayong": "TH-21",
			"Roi Et": "TH-45",
			"Sa Kaeo": "TH-27",
			"Sakon Nakhon": "TH-47",
			"Samut Prakan": "TH-11",
			"Samut Sakhon": "TH-74",
			"Samut Songkhram": "TH-75",
			"Saraburi": "TH-19",
			"Satun": "TH-91",
			"Sing Buri": "TH-17",
			"Sisaket": "TH-33",
			"Songkhla": "TH-90",
			"Sukhothai": "TH-64",
			"Suphan Buri": "TH-72",
			"Surat Thani": "TH-84",
			"Surin": "TH-32",
			"Tak": "TH-63",
			"Trang": "TH-92",
			"Trat": "TH-23",
			"Ubon Ratchathani": "TH-34",
			"Udon Thani": "TH-41",
			"Uthai Thani": "TH-61",
			"Uttaradit": "TH-53",
			"Yala": "TH-95",
			"Yasothon": "TH-35"
		},
		"province_alternate_names": {
			"Amnat Charoen": null,
			"Ang Thong": null,
			"Bangkok": ["Krung Thep Maha Nakhon"],
			"Bueng Kan": null,
			"Buriram": ["Buri Ram"],
			"Chachoengsao": null,
			"Chai Nat": null,
			"Chaiyaphum": null,
			"Chanthaburi": null,
			"Chiang Mai": null,
			"Chiang Rai": null,
			"Chon Buri": null,
			"Chumphon": null,
			"Kalasin": null,
			"Kamphaeng Phet": null,
			"Kanchanaburi": null,
			"Khon Kaen": null,
			"Krabi": null,
			"Lampang": null,
			"Lamphun": null,
			"Loei": null,
			"Lopburi": ["Lop Buri"],
			"Mae Hong Son": null,
			"Maha Sarakham": null,
			"Mukdahan": null,
			"Nakhon Nayok": null,
			"Nakhon Pathom": null,
			"Nakhon Phanom": null,
			"Nakhon Ratchasima": null,
			"Nakhon Sawan": null,
			"Nakhon Si Thammarat": null,
			"Nan": null,
			"Narathiwat": null,
			"Nong Bua Lam Phu": null,
			"Nong Khai": null,
			"Nonthaburi": null,
			"Pathum Thani": null,
			"Pattani": null,
			"Pattaya": null,
			"Phangnga": null,
			"Phatthalung": null,
			"Phayao": null,
			"Phetchabun": null,
			"Phetchaburi": null,
			"Phichit": null,
			"Phitsanulok": null,
			"Phra Nakhon Si Ayutthaya": null,
			"Phrae": null,
			"Phuket": null,
			"Prachin Buri": null,
			"Prachuap Khiri Khan": null,
			"Ranong": null,
			"Ratchaburi": null,
			"Rayong": null,
			"Roi Et": null,
			"Sa Kaeo": null,
			"Sakon Nakhon": null,
			"Samut Prakan": null,
			"Samut Sakhon": null,
			"Samut Songkhram": null,
			"Saraburi": null,
			"Satun": null,
			"Sing Buri": null,
			"Sisaket": ["Si Sa Ket"],
			"Songkhla": null,
			"Sukhothai": null,
			"Suphan Buri": null,
			"Surat Thani": null,
			"Surin": null,
			"Tak": null,
			"Trang": null,
			"Trat": null,
			"Ubon Ratchathani": null,
			"Udon Thani": null,
			"Uthai Thani": null,
			"Uttaradit": null,
			"Yala": null,
			"Yasothon": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Province",
		"checkout_zone_placeholder": "Province"
	},
	"Timor Leste": {
		"code": "TL",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tl-67d5ac594d36742a7056023b8323cc9ca6d45076973ce3a377b9b2f7be65c227.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Togo": {
		"code": "TG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tg-3d32336a265064b50f45029e913cca70087811aca9b4043d94c2aa6909ddf403.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Tokelau": {
		"code": "TK",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tk-53658460c1ddd4ecdf442a1eeec862bf1141183559d2603575c2fc7881b29c42.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Tonga": {
		"code": "TO",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/to-c281f572c6de0cc1f92136acf977298c7a8472d377a43e8475b4e76cf6a45263.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Trinidad and Tobago": {
		"code": "TT",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tt-f7628af308d4b6a5e30370d173ac6b8b1151dfea4415faeaf21965ed19b8b09d.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Tristan da Cunha": {
		"code": "TA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ta-390f7b76dab7f5d1c8693e2fb6eaaa23ea49c51cad8fb40adcf8eafa5704ec3f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Tunisia": {
		"code": "TN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tn-1d5ad3bb6e975fc7bfc718d6e04fd59da5381b6ea75eced8e14197e897fc1ee9.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Turkey": {
		"code": "TR",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tr-07c4650655213ff4393d7be2563d3e95eb26cdc0f08f208951e8cba9e860d062.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Turkmenistan": {
		"code": "TM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tm-343dd2b01707a6539c32ef6b8e6e9c6740465049f507dc4c4ac21eadc3c9fccb.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Turks and Caicos Islands": {
		"code": "TC",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tc-2e92bdaae7481ce4fa86a7252290875e0c552c13a57b1b818278b10e38f796b4.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Tuvalu": {
		"code": "TV",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/tv-6c3d868cb703f91a90b338a6b6c4f7aab35314815e1841655edf4f2d805bf014.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Uganda": {
		"code": "UG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ug-0debf20222e989183ca2349363c9193224982d1d942e4c0b99e40a2c10d32b0f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Ukraine": {
		"code": "UA",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ua-b58d698f846fbffd708df03df9b6ef4613038935f064539d914e6e4754c4fb6c.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"United Arab Emirates": {
		"code": "AE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ae-3cce5239a0c9c329a8f2f0e6f900a7d58e463bd79ff4dd8cc9f2d89e057777d4.svg",
		"label": "Emirate",
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cs",
		"provinces_beta": null,
		"province_label": "Emirate",
		"provinces": ["Abu Dhabi", "Ajman", "Dubai", "Fujairah", "Ras al-Khaimah", "Sharjah", "Umm al-Quwain"],
		"province_labels": {
			"Abu Dhabi": "Abu Dhabi",
			"Ajman": "Ajman",
			"Dubai": "Dubai",
			"Fujairah": "Fujairah",
			"Ras al-Khaimah": "Ras al-Khaimah",
			"Sharjah": "Sharjah",
			"Umm al-Quwain": "Umm al-Quwain"
		},
		"province_codes": {
			"Abu Dhabi": "AZ",
			"Ajman": "AJ",
			"Dubai": "DU",
			"Fujairah": "FU",
			"Ras al-Khaimah": "RK",
			"Sharjah": "SH",
			"Umm al-Quwain": "UQ"
		},
		"province_alternate_names": {
			"Abu Dhabi": null,
			"Ajman": null,
			"Dubai": null,
			"Fujairah": null,
			"Ras al-Khaimah": null,
			"Sharjah": null,
			"Umm al-Quwain": null
		},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Emirate",
		"checkout_zone_placeholder": "Emirate"
	},
	"United Kingdom": {
		"code": "GB",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/gb-de46013c87c1d6b0e4804a6bd8be50f2c5f961c5adbc42ba40b8913af33afe75.svg",
		"label": null,
		"zip_label": "Postcode",
		"zip_placeholder": "Postcode",
		"zip_required": true,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": ["British Forces", "England", "Northern Ireland", "Scotland", "Wales"],
		"province_labels": {
			"British Forces": "British Forces",
			"England": "England",
			"Northern Ireland": "Northern Ireland",
			"Scotland": "Scotland",
			"Wales": "Wales"
		},
		"province_codes": {
			"British Forces": "BFP",
			"England": "ENG",
			"Northern Ireland": "NIR",
			"Scotland": "SCT",
			"Wales": "WLS"
		},
		"province_alternate_names": {
			"British Forces": null,
			"England": null,
			"Northern Ireland": null,
			"Scotland": null,
			"Wales": null
		},
		"checkout_zip_label": "Postcode",
		"checkout_zip_placeholder": "Postcode",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"United States": {
		"code": "US",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/us-1c64c14fa68916dba409ddf0e38ca5dc8bd262b959a5814ecb6667096b35efa5.svg",
		"label": "State",
		"zip_label": "ZIP code",
		"zip_placeholder": "ZIP code",
		"zip_required": true,
		"address_format": "n_a_a_c_csp",
		"provinces_beta": null,
		"province_label": "State",
		"provinces": ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Federated States of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "Virgin Islands", "Armed Forces Americas", "Armed Forces Europe", "Armed Forces Pacific"],
		"province_labels": {
			"Alabama": "Alabama",
			"Alaska": "Alaska",
			"American Samoa": "American Samoa",
			"Arizona": "Arizona",
			"Arkansas": "Arkansas",
			"California": "California",
			"Colorado": "Colorado",
			"Connecticut": "Connecticut",
			"Delaware": "Delaware",
			"Florida": "Florida",
			"Georgia": "Georgia",
			"Guam": "Guam",
			"Hawaii": "Hawaii",
			"Idaho": "Idaho",
			"Illinois": "Illinois",
			"Indiana": "Indiana",
			"Iowa": "Iowa",
			"Kansas": "Kansas",
			"Kentucky": "Kentucky",
			"Louisiana": "Louisiana",
			"Maine": "Maine",
			"Marshall Islands": "Marshall Islands",
			"Maryland": "Maryland",
			"Massachusetts": "Massachusetts",
			"Michigan": "Michigan",
			"Federated States of Micronesia": "Micronesia",
			"Minnesota": "Minnesota",
			"Mississippi": "Mississippi",
			"Missouri": "Missouri",
			"Montana": "Montana",
			"Nebraska": "Nebraska",
			"Nevada": "Nevada",
			"New Hampshire": "New Hampshire",
			"New Jersey": "New Jersey",
			"New Mexico": "New Mexico",
			"New York": "New York",
			"North Carolina": "North Carolina",
			"North Dakota": "North Dakota",
			"Northern Mariana Islands": "Northern Mariana Islands",
			"Ohio": "Ohio",
			"Oklahoma": "Oklahoma",
			"Oregon": "Oregon",
			"Palau": "Palau",
			"Pennsylvania": "Pennsylvania",
			"Puerto Rico": "Puerto Rico",
			"Rhode Island": "Rhode Island",
			"South Carolina": "South Carolina",
			"South Dakota": "South Dakota",
			"Tennessee": "Tennessee",
			"Texas": "Texas",
			"Virgin Islands": "U.S. Virgin Islands",
			"Utah": "Utah",
			"Vermont": "Vermont",
			"Virginia": "Virginia",
			"Washington": "Washington",
			"District of Columbia": "Washington DC",
			"West Virginia": "West Virginia",
			"Wisconsin": "Wisconsin",
			"Wyoming": "Wyoming",
			"Armed Forces Americas": "Armed Forces Americas",
			"Armed Forces Europe": "Armed Forces Europe",
			"Armed Forces Pacific": "Armed Forces Pacific"
		},
		"province_codes": {
			"Alabama": "AL",
			"Alaska": "AK",
			"American Samoa": "AS",
			"Arizona": "AZ",
			"Arkansas": "AR",
			"California": "CA",
			"Colorado": "CO",
			"Connecticut": "CT",
			"Delaware": "DE",
			"District of Columbia": "DC",
			"Federated States of Micronesia": "FM",
			"Florida": "FL",
			"Georgia": "GA",
			"Guam": "GU",
			"Hawaii": "HI",
			"Idaho": "ID",
			"Illinois": "IL",
			"Indiana": "IN",
			"Iowa": "IA",
			"Kansas": "KS",
			"Kentucky": "KY",
			"Louisiana": "LA",
			"Maine": "ME",
			"Marshall Islands": "MH",
			"Maryland": "MD",
			"Massachusetts": "MA",
			"Michigan": "MI",
			"Minnesota": "MN",
			"Mississippi": "MS",
			"Missouri": "MO",
			"Montana": "MT",
			"Nebraska": "NE",
			"Nevada": "NV",
			"New Hampshire": "NH",
			"New Jersey": "NJ",
			"New Mexico": "NM",
			"New York": "NY",
			"North Carolina": "NC",
			"North Dakota": "ND",
			"Northern Mariana Islands": "MP",
			"Ohio": "OH",
			"Oklahoma": "OK",
			"Oregon": "OR",
			"Palau": "PW",
			"Pennsylvania": "PA",
			"Puerto Rico": "PR",
			"Rhode Island": "RI",
			"South Carolina": "SC",
			"South Dakota": "SD",
			"Tennessee": "TN",
			"Texas": "TX",
			"Utah": "UT",
			"Vermont": "VT",
			"Virginia": "VA",
			"Washington": "WA",
			"West Virginia": "WV",
			"Wisconsin": "WI",
			"Wyoming": "WY",
			"Virgin Islands": "VI",
			"Armed Forces Americas": "AA",
			"Armed Forces Europe": "AE",
			"Armed Forces Pacific": "AP"
		},
		"province_alternate_names": {
			"Alabama": null,
			"Alaska": null,
			"American Samoa": null,
			"Arizona": null,
			"Arkansas": null,
			"California": null,
			"Colorado": null,
			"Connecticut": null,
			"Delaware": null,
			"District of Columbia": null,
			"Federated States of Micronesia": null,
			"Florida": null,
			"Georgia": null,
			"Guam": null,
			"Hawaii": null,
			"Idaho": null,
			"Illinois": null,
			"Indiana": null,
			"Iowa": null,
			"Kansas": null,
			"Kentucky": null,
			"Louisiana": null,
			"Maine": null,
			"Marshall Islands": null,
			"Maryland": null,
			"Massachusetts": null,
			"Michigan": null,
			"Minnesota": null,
			"Mississippi": null,
			"Missouri": null,
			"Montana": null,
			"Nebraska": null,
			"Nevada": null,
			"New Hampshire": null,
			"New Jersey": null,
			"New Mexico": null,
			"New York": null,
			"North Carolina": null,
			"North Dakota": null,
			"Northern Mariana Islands": null,
			"Ohio": null,
			"Oklahoma": null,
			"Oregon": null,
			"Palau": null,
			"Pennsylvania": null,
			"Puerto Rico": null,
			"Rhode Island": null,
			"South Carolina": null,
			"South Dakota": null,
			"Tennessee": null,
			"Texas": null,
			"Utah": null,
			"Vermont": null,
			"Virginia": null,
			"Washington": null,
			"West Virginia": null,
			"Wisconsin": null,
			"Wyoming": null,
			"Virgin Islands": null,
			"Armed Forces Americas": null,
			"Armed Forces Europe": null,
			"Armed Forces Pacific": null
		},
		"checkout_zip_label": "ZIP code",
		"checkout_zip_placeholder": "ZIP code",
		"checkout_zone_label": "State",
		"checkout_zone_placeholder": "State"
	},
	"United States Minor Outlying Islands": {
		"code": "UM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/um-1c64c14fa68916dba409ddf0e38ca5dc8bd262b959a5814ecb6667096b35efa5.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "State"
	},
	"Uruguay": {
		"code": "UY",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/uy-ba9858ec07e8aefb8ff27c8398dc213b80fd69379d834546231d48aa62c435bb.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Uzbekistan": {
		"code": "UZ",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/uz-0123edd5c4db7c4b1044825299925de140f7929dd91ec3be2764980ee234d134.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Vanuatu": {
		"code": "VU",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/vu-cb29e23b988fe42de8c05858f8b7f4609bc9e6b9c96ab7a0b70ae10a4df09e11.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Venezuela": {
		"code": "VE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ve-94d27d5388c9ecd6afd677573c8eb50eead088ce86d031f19affbb10b8db1ed4.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Vietnam": {
		"code": "VN",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/vn-90fae192a098f9bda964d4c594a32e53c8fc3242f5d6591973bcf959c5c4d8b3.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Virgin Islands, British": {
		"code": "VG",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/vg-c90981b23d2d3856297e5aa445ac5046ef0f03d7ff4242324c327abe5ab79a81.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Wallis And Futuna": {
		"code": "WF",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/wf-10d09cbc2a8b2219da141bbacc940ec8f45a55b36b0dd8f92d07c6c93331f85f.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Western Sahara": {
		"code": "EH",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/eh-e5dfc140ba81111d3b3346124cedd198477b2f5a61a7a63bc0c1dacdc64c9dae.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Yemen": {
		"code": "YE",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/ye-d9453819872a7de3c717436f9d1a7e6650a3bec2d72bdfc1f581b80cf6bcc278.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Zambia": {
		"code": "ZM",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/zm-873696887f25527b132857132aea373dda7d1de1e02803dcbbe784e382bcf7d8.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_cp",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	},
	"Zimbabwe": {
		"code": "ZW",
		"flag_path": "\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/flags\/zw-22a4ab7855acfb0b92ae062631162e4a3b9944ace38a168eb383644e71a0a863.svg",
		"label": null,
		"zip_label": "Postal code",
		"zip_placeholder": "Postal code",
		"zip_required": false,
		"address_format": "n_a_a_c_c",
		"provinces_beta": null,
		"province_label": "Region",
		"provinces": null,
		"province_labels": null,
		"province_codes": {},
		"province_alternate_names": {},
		"checkout_zip_label": "Postal code",
		"checkout_zip_placeholder": "Postal code",
		"checkout_zone_label": "Region",
		"checkout_zone_placeholder": "Region"
	}
}